/* Click color change image product */
jQuery(document).ready(function($) {
  jQuery('.engoj_select_color a').each(function(){
    jQuery(this).on("click",function(){
      var engoImage = jQuery(this).data('engojvariant-img');
      jQuery(this).parents('.engoj_grid_parent').find('.engoj_find_img img').attr({ src: engoImage }); 
      return false;
    });
  });
 jQuery(".myaccountOuter-ul li a").click(function(){
    jQuery(this).closest(".tab-pd-details").next().find(".active").removeClass('active');
    var id = jQuery(this).attr('href');
    var siblingsDom = jQuery(this).parent().siblings();
    var siblingsId = siblingsDom.find('a');
    jQuery(this).addClass('active');
    siblingsDom.find('a').removeClass('active');
    jQuery(id).addClass('active');
  })
  $(document).on('click', 'input.enj-add-to-cart-btn', function() {
      $('body').addClass('cartover');
  })
  if ($(window).width() < 990) { // 参数对比模板
    const width1 = $(window).width()/3;
    $('.compare-table-container .table-row>td').css('width', width1+'px');
  } 
  spliceElementMethod(1);
  chatStyleChange();
  klarnaChangeStyle();
});

function chatStyleChange() { // 聊天插件样式控制
  setTimeout(function() {
    const chatDom = document.getElementById("ShopifyChat") ||  null ;
    const chatDom1 = chatDom ? chatDom.shadowRoot : null;
    if (chatDom1) {
      chatDomChange(chatDom1)
      chatDom.addEventListener('click', function(){
        const chatDom = document.getElementById("ShopifyChat") ||  null ;
        const chatDom1 = chatDom ? chatDom.shadowRoot : null;
        chatDomChange(chatDom1);
      })
    }
    $("#ShopifyChat").css('opacity', 1);
    // const klarnaDom = document.getElementById("klarna-message-content") ||  null ;
    // const klarnaDom1 = klarnaDom ? klarnaDom.querySelector('klarna-placement').shadowRoot : null;
    // if (klarnaDom1) {
    //   const klarnaDom2 = klarnaDom1.querySelector('.container');
    //   const klarnaDom3 = klarnaDom1.querySelector('.text-wrapper');
    //   klarnaDom2.style="line-height: 17px; border-color: #fff;"
    //   //klarnaDom3.style="margin-left: 0"
    // }
  },6000)
}

function klarnaChangeStyle() {
  setTimeout(function() {
    const klarnaDom = document.getElementById("klarna-message-content") ||  null ;
    const klarnaDom1 = klarnaDom ? klarnaDom.querySelector('klarna-placement').shadowRoot : null;
    if (klarnaDom1) {
      const klarnaDom2 = klarnaDom1.querySelector('.container');
      const klarnaDom3 = klarnaDom1.querySelector('.text-wrapper');
      klarnaDom2.style="line-height: 17px; border-color: #fff;"
      //klarnaDom3.style="margin-left: 0"
    }
    $('#klarna-message-content klarna-placement').css('opacity', 1)
  }, 1700)
}

function chatDomChange(chatDom1) {
    const chatDom2 = chatDom1.querySelector('.chat-toggle');
    const domButton1  = chatDom1.querySelector('.chat-app--close-button') || null
    const chatBut = chatDom1.querySelector('.chat-notification') || null
    if (chatDom2) {
       const chatDom3 = chatDom2 && chatDom2.querySelector('svg') || null;
       if ($(window).width() < 990 ) { 
         chatDom2.style = 'height: 40px !important; width: 40px !important; background: rgb(244, 132, 26); opacity: 0.9';
         chatDom3.style = 'height: 40px;';
       } else {
         chatDom2.style = 'height: 48px !important; width: 48px !important; background: rgb(244, 132, 26); opacity: 0.9';
         chatDom3.style = 'height: 48px;';
       }
       chatDom2 && chatDom2.classList.remove('icon-only');
       chatDom2 && chatDom2.classList.remove('mobile-only'); 
    }
    if (domButton1) {
       if ($(window).width() < 990 ) { 
         domButton1.style = 'height: 40px !important; width: 40px !important; background: rgb(244, 132, 26); opacity: 0.9 '
       } else {
         domButton1.style = 'height: 48px !important; width: 48px !important; background: rgb(244, 132, 26); opacity: 0.9 '
       }
    }
    if (chatBut) {
        chatBut.style = 'display: none';
    }
    if ($(window).width() < 990 ) { //移动端
      const chatDom4 = chatDom1.querySelector('.chat-app--is-open') || null; //打开状态
      const chatDom5 = chatDom1.querySelector('.customer-info-form__online-container') || null
      const chatDom6 = chatDom1.querySelector('.chat-messages') || null   
      if (chatDom4) {
        $("#ShopifyChat").css('bottom', '0px');
      } else {
        $("#ShopifyChat").css('bottom', '110px');
      }
      
      if (chatDom5) {
        chatDom5.style = 'height: 80%';
      }

      if (chatDom6) {
        chatDom6.style = 'flex-grow: 0.9';
      }
    }
}

function spliceElementMethod(isReviews) { // 评价去重 isReviews 为1是用户评论, 2图片，3弹窗图片
    let reviewsContainer = $('.reviewsContainer .jdgm-all-reviews__body')
    let author = reviewsContainer && reviewsContainer.find('.jdgm-rev__author') || []
    if (isReviews == 2) {
        reviewsContainer = $('.reviewsContainer .jdgm-gallery')
        author = reviewsContainer && reviewsContainer.find('.jdgm-gallery__thumbnail') || []
    }
    if (isReviews == 3) {
        reviewsContainer = $('.jm-mfp-main .jdgm-gallery')
        author = reviewsContainer && reviewsContainer.find('.jdgm-gallery__thumbnail') || []
    }
    
    for (let i=0; i< author.length -1; i++) {
     for (let j= i + 1; j< author.length; j++) {
       let preText = isReviews == 1 ? $(author[i]).text() : isReviews == 2 ? $(author[i]).attr('data-src') : $(author[i]).attr('src') 
       let nextText = isReviews == 1 ? $(author[j]).text() :  isReviews == 2 ?  $(author[j]).attr('data-src') :  $(author[j]).attr('src')
       if(isReviews == 2 || isReviews == 3){
         const srcUrl1 = isReviews == 2 ? $(author[i]).attr('data-src') : $(author[i]).attr('src')
         const srcUrl2 = isReviews == 2 ?  $(author[j]).attr('data-src') :  $(author[j]).attr('src')
         const splitData1 = srcUrl1.indexOf('__0__') > -1 ? srcUrl1.split('__0__') : srcUrl1
         const splitData2 = srcUrl2.indexOf('__0__') > -1 ? srcUrl2.split('__0__') : srcUrl2
         preText = splitData1.length > 1 ? splitData1[1].substring(splitData1[1].indexOf('__')+2) : srcUrl1
         nextText = splitData2.length > 1 ? splitData2[1].substring(splitData2[1].indexOf('__')+2) : srcUrl2
       }
       if (preText == nextText) {
         if (isReviews == 1) {
           $(author[j]).parents('.jdgm-rev').remove()
         } else {
            const domWrapper = $(author[j]).parent('.jdgm-gallery__thumbnail-wrapper')
            const nameStr = window.getComputedStyle(domWrapper[0], '::before')
            if(isReviews == 2){
                i != 7 &&  $(author[j]).parents('.jdgm-gallery__thumbnail-link').css('display', 'none') 
            } else {
                $(author[j]).parents('.jdgm-gallery__thumbnail-link').remove()
            }
         }
       }
     }
   }
}

/* Live search */
var engoAutoComplate = {
  initProductsRecently: function() {
    var self = this;
    if (!jQuery.cookie('brilliant_products_recently') || jQuery.cookie('brilliant_products_recently') == null) {      
      $(".engoj-recently-wrapper").append('<div class="no-products" style="flex-direction: column;"> <!--?xml version="1.0" encoding="iso-8859-1"?--> <!-- Generator: Adobe Illustrator 17.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --> <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewbox="0 0 455 455" style="enable-background:new 0 0 455 455;" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"> <g> <path d="M360.967,130.599c-4.06-0.818-8.018,1.8-8.841,5.86c-0.823,4.06,1.801,8.018,5.86,8.841 c1.147,0.232,2.013,1.286,2.013,2.45v160c0,1.355-1.145,2.5-2.5,2.5H179.676c-4.142,0-7.5,3.357-7.5,7.5s3.358,7.5,7.5,7.5H357.5 c9.649,0,17.5-7.851,17.5-17.5v-160C375,139.46,369.099,132.247,360.967,130.599z"></path> <path d="M274.824,130.25H97.5c-9.649,0-17.5,7.851-17.5,17.5v160c0,8.063,5.48,15.046,13.326,16.982 c0.604,0.149,1.208,0.221,1.803,0.221c3.369,0,6.432-2.287,7.276-5.705c0.992-4.021-1.463-8.086-5.484-9.078 c-0.955-0.235-1.92-1.143-1.92-2.42v-160c0-1.355,1.145-2.5,2.5-2.5h177.324c4.142,0,7.5-3.357,7.5-7.5 S278.966,130.25,274.824,130.25z"></path> <path d="M235.363,170.798c-2.655-0.363-5.3-0.548-7.863-0.548c-31.706,0-57.5,25.794-57.5,57.5c0,2.563,0.185,5.209,0.548,7.863 c0.515,3.759,3.731,6.483,7.421,6.483c0.339,0,0.682-0.023,1.027-0.07c4.104-0.562,6.975-4.345,6.413-8.448 c-0.271-1.982-0.409-3.943-0.409-5.828c0-23.435,19.065-42.5,42.5-42.5c1.884,0,3.845,0.138,5.828,0.409 c4.108,0.564,7.886-2.309,8.448-6.413C242.338,175.143,239.467,171.359,235.363,170.798z"></path> <path d="M219.127,284.636c2.789,0.407,5.605,0.614,8.373,0.614c31.706,0,57.5-25.794,57.5-57.5c0-2.77-0.207-5.587-0.613-8.373 c-0.599-4.099-4.408-6.934-8.505-6.337c-4.099,0.599-6.936,4.406-6.337,8.505c0.303,2.071,0.456,4.158,0.456,6.205 c0,23.435-19.065,42.5-42.5,42.5c-2.044,0-4.132-0.153-6.205-0.456c-4.099-0.6-7.907,2.238-8.505,6.337 S215.028,284.037,219.127,284.636z"></path> <path d="M318.5,203.25c9.098,0,16.5-7.402,16.5-16.5c0-8.318-6.227-15.355-14.484-16.37c-2.293-0.277-4.585,0.509-6.218,2.142 l-10.027,10.027c-1.633,1.632-2.422,3.926-2.141,6.217C303.145,197.023,310.183,203.25,318.5,203.25z"></path> <path d="M117.5,114.75h30c4.142,0,7.5-3.357,7.5-7.5s-3.358-7.5-7.5-7.5h-30c-4.142,0-7.5,3.357-7.5,7.5 S113.358,114.75,117.5,114.75z"></path> <path d="M388.367,66.633C345.397,23.664,288.268,0,227.5,0S109.603,23.664,66.633,66.633C23.664,109.603,0,166.732,0,227.5 s23.664,117.897,66.633,160.867C109.603,431.336,166.732,455,227.5,455s117.897-23.664,160.867-66.633 C431.336,345.397,455,288.268,455,227.5S431.336,109.603,388.367,66.633z M15,227.5C15,110.327,110.327,15,227.5,15 c55.894,0,106.807,21.703,144.783,57.11L72.11,372.283C36.703,334.307,15,283.395,15,227.5z M227.5,440 c-55.894,0-106.807-21.703-144.783-57.11L382.89,82.717C418.297,120.693,440,171.606,440,227.5C440,344.673,344.673,440,227.5,440z "></path> </g> </svg> <div class="title_noprod"> <span> Sorry, there are no products. </span> </div> </div>');
    } else {
      $(".engoj-recently-wrapper > .no-products").remove();
      var arr = jQuery.cookie('brilliant_products_recently').split('|'); // split string to array
      for ( var i = 0; i < arr.length; i++){
        var handle = arr[i]; 
        self.ajaxProductsRecently(handle);
      }

      $('.js_prod_recent').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        focusOnSelect: true,
        
        prevArrow: '<button type="button" class="slick-brand-prev fa fa-angle-left"></button>',
        nextArrow: '<button type="button" class="slick-brand-next fa fa-angle-down"></button>',

        responsive: [
          {
            breakpoint: 1200,
            settings: {
            }
          },
          {
            breakpoint: 768,
            settings: {
            }
          },

          {
            breakpoint: 574,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    }
  },

  ajaxProductsRecently: function(handle) {
    var ajaxUrl = '/products/'+handle+'.js',
        result     = new Array();
    jQuery.ajax({
      type: 'GET',
      dataType: "json",
      url: ajaxUrl,
      beforeSend: function() {
        jQuery(".js_prod_recent").append('<div class="items d-flex align-items-md-center align-items-start engoj-recently-'+handle+'"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></div>');
      },
      success: function(product) {
        var title            = product.title,
            price            = product.price,
            handle           = product.handle,
            image            = product.featured_image,
            template         = '<div class="img_left"> <a href="/products/'+ handle +'"> <img loading="lazy" width="" height="" src="' + image + '" class="img-responsive" alt="'+title+'"> </a> </div> <div class="info_right position-absolute"> <a class="product-title" href="/products/'+ handle +'">'+title+'</a> <p class="price-product"><span class="price">'+ Shopify.formatMoney(price, window.money_format) +'</span></p> <div class="product-icon-action"> <div class="add-to-cart"> <a href="/products/'+ handle +'"><span>Buy now</span></a> </div> </div> </div>';       
            jQuery('.engoj-recently-'+handle).html(template);
      }
    });
  },

  ajaxProductItems : function( input_element, result_wrapper, result_element ){
    var ajaxUrl  = '/search',
        result     = new Array(),
        keyword   = input_element.val();

    jQuery.ajax({
        type: 'GET',
        data: {
            q: "*" + keyword + "*",
            type: "product",
            view: "json",
        },
        dataType: "json",      
        url: ajaxUrl,
        beforeSend: function() {
          result_wrapper.show();
          result_element.html('<p class="col-12"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#000" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg> Wird geladen...</p>');
        },
        complete:function(){
        },
        success: function ( reponse ) {
          var htmlbox = '';
          //result_element.html('');
          if( reponse.length > 0 ){
            for (var i = 0; i < reponse.length; i++) {

              var item              = reponse[i],
                  title            = item.title,
                  price            = item.price,
                  handle           = item.handle,
                  image            = item.featured_image,
                  compare_price    = item.compare_at_price  ? '<s class="price-old">' + Shopify.formatMoney(item.compare_at_price, window.money_format) + '</s>' : "",
                  sold_out	       = item.available          ? "" : "<span class='item-sold-out'>Ausverkauft</span> ",
                  price            = item.available          ? item.price : item.out_stock_nofication,
                  hightlight     = title.replace(new RegExp('(' + keyword + ')', 'gi'), '<span class="hightlight">$1</span>'),
                  template         = '<div class="col-lg-4 col-sm-6 col-md-6"><ul class="prod_sidebar"><li class="product_info">'
                                      + '<a href="/products/'+ handle +'">'
                                      + '<img loading="lazy" width="" height="" style="width: 100% "src="' + image + '" class="img-responsive"/>' 
                                      +'</a>'
                                      +'<h4 class="title-product"><a href="/products/'+ handle +'">' + hightlight +'</a></h4>'
                                      +'<span><p class="price-product mb-0"><span class="price">'+ Shopify.formatMoney(price, window.money_format) +'</span>'+ compare_price +'</p></span>'
                  					  + sold_out
                                      +'</li></ul></div>';
              htmlbox = htmlbox + template;
                 

            }
            result_element.html(htmlbox);
            
            if($('.js_productSearchResults .js_search_results li').length){
              $('.js_productSearchResults').show();
           
            }
          }else{
            result_element.html('<p class="col-12">Für Ihre Suche wurde kein Ergebnis gefunden.</p>');
             $('.js_productSearchResults').show();
          }
       }     
    });

  },
  
  ajaxSearch : function( options ){    
    var     ajax_timeout,
    		ajax_lost_focus,
            self        = this,
            search_input_id    = options.search_input.length   > 0   ? options.search_input    : '.js_engo_autocomplate',
            wrapper_id         = options.result_wrapper.length > 0   ? options.result_wrapper  : '.js_productSearchResults',
            result_id          = options.result_element.length > 0   ? options.result_element  : '.js_search_results';

    jQuery( document ).delegate( search_input_id ,'keyup',function( event ){
      var keyword           = jQuery(this).val(),
          search_element    = jQuery(this),
          result_wrapper    = jQuery( wrapper_id ),
          result_element    = result_wrapper.children( result_id );
        
      if( ajax_timeout ){ 
        clearTimeout(ajax_timeout);
      } 

      ajax_timeout = setTimeout(function() {
        if( keyword.length >= 2 ){
            self.ajaxProductItems( search_element ,result_wrapper, result_element );
        }else if( keyword.length >= 1 ){
            result_element.html('<p class="col-12">Sie müssen mindestens 2 Zeichen eingeben.</p>');
        }else{
            result_element.html(popular_searches_html);
        }
      },300);       
    }); 

  },
  
  init : function( options ){
    if($.trim($(".js_search_results").html()) != ""){
        popular_searches_html=$.trim($(".js_search_results").html());
    }
    this.ajaxSearch( options );
  }
  
}

jQuery(document).ready(function($) {  
  engoAutoComplate.init({
    "search_input"      :   ".js_engo_autocomplate",
    "result_wrapper"   :   ".js_productSearchResults",
    "result_element"   :   ".js_search_results"
  });
      
  engoAutoComplate.initProductsRecently();
});

var popular_searches_html="Sie müssen mindestens 2 Zeichen eingeben.";
jQuery(document).ready(function($) {
  "use strict";

  
  function jsProdDetails(){
    if($(window).width() < 576){
    	$('.js_sticy_imgmb').addClass('js_prod_detail')
    }
    $(window).resize(function() {
      if($(window).width() < 576){
        $('.js_sticy_imgmb').addClass('js_prod_detail')
      }
    });
    
    $('.js_prod_detail').slick({
      dots: true,
      arrows:true,
      infinite: false,
      speed: 300,
      
      autoplay:false,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow:'<button type="button" class="next-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> <g id="Forma_1"> <path fill-rule="evenodd" clip-rule="evenodd" d="M834.107,232.981L618.365,17.218c-9.3-9.624-24.779-9.624-34.405,0 c-9.299,9.303-9.299,24.778,0,34.059l174.447,174.441H182.759c-13.42,0.021-24.086,10.686-24.086,24.108 c0,13.417,10.666,24.436,24.086,24.436h575.648L583.96,448.375c-9.299,9.63-9.299,25.12,0,34.401 c9.626,9.632,25.128,9.632,34.405,0l215.742-215.742C843.733,257.739,843.733,242.263,834.107,232.981z"/> </g> </g> <g id="Forma_1_copy_1_"> </g> </svg></button>',
      prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> </g> <g id="Forma_1_copy_1_"> <g id="Forma_1_copy"> <path fill-rule="evenodd" clip-rule="evenodd" d="M811.881,225.728H245.96L417.457,51.275c9.143-9.269,9.143-24.751,0-34.055 c-9.463-9.627-24.679-9.627-33.821,0l-212.1,215.762c-9.462,9.282-9.462,24.765,0,34.054l212.1,215.742 c9.12,9.627,24.358,9.627,33.821,0c9.143-9.276,9.143-24.772,0-34.4L245.96,274.265h565.921c13.192,0,23.68-11.014,23.68-24.434 C835.561,236.411,825.073,225.749,811.881,225.728z"/> </g> </g> </svg></button>',
    });

  }
  if($('#related-product-new').length && $.trim($('#related-product-new').html()) == '' && $('#related-product-new').attr('product_id')){
    ajaxGetRecommendations($('#related-product-new').attr('product_id'),'section-related-product',10,'#related-product-new',function(ele_obj, data){
      if(data){
        $('#related-product-new').html(data);
        jsProdRelate();
      }   
    });
  }
  function jsProdRelate(){
    const winWidth =  $('#shopify-section-section-related-product').width()
    const winWidth1 =  $(window).width() > 990 ? ((Number(winWidth)+30)/4)+'px' : ((Number(winWidth)+30)/2)+'px'
    console.log('winWidth123',winWidth1)
    
    if($('#related-product-new').length && $.trim($('#related-product-new').html()) == ''){
      return;
    }
    if ($(window).width() > 990){
      $('.js_product_related .col-12').css('min-width', winWidth1);
      $('#recently-viewed-products .col-12').css('min-width', winWidth1);
      $('.js_product_related').slick({
      dots: false,
      arrows:true,
      infinite: true,
      speed: 300,
      autoplay:false,
      
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      nextArrow:'<button type="button" class="next-slide" title="next"><i class="fa fa-angle-right"></i></button>',
      prevArrow:'<button type="button" class="prev-slide" title="prev"><i class="fa fa-angle-left"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false, 
            arrows: true
          }
        }
      ]
    });
    } else {
      $('.content-page-detail .js_prod_sub2 .engoj-nav-item').eq(0).find('img').css('border', '1px solid #f4841a');
    }
  }
  
  function jsCollection(){
    $('.js_collection').slick({
      dots: true,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 3,
      slidesToScroll: 2,
      
      nextArrow:'<button type="button" class="next-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> <g id="Forma_1"> <path fill-rule="evenodd" clip-rule="evenodd" d="M834.107,232.981L618.365,17.218c-9.3-9.624-24.779-9.624-34.405,0 c-9.299,9.303-9.299,24.778,0,34.059l174.447,174.441H182.759c-13.42,0.021-24.086,10.686-24.086,24.108 c0,13.417,10.666,24.436,24.086,24.436h575.648L583.96,448.375c-9.299,9.63-9.299,25.12,0,34.401 c9.626,9.632,25.128,9.632,34.405,0l215.742-215.742C843.733,257.739,843.733,242.263,834.107,232.981z"/> </g> </g> <g id="Forma_1_copy_1_"> </g> </svg></button>',
      prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> </g> <g id="Forma_1_copy_1_"> <g id="Forma_1_copy"> <path fill-rule="evenodd" clip-rule="evenodd" d="M811.881,225.728H245.96L417.457,51.275c9.143-9.269,9.143-24.751,0-34.055 c-9.463-9.627-24.679-9.627-33.821,0l-212.1,215.762c-9.462,9.282-9.462,24.765,0,34.054l212.1,215.742 c9.12,9.627,24.358,9.627,33.821,0c9.143-9.276,9.143-24.772,0-34.4L245.96,274.265h565.921c13.192,0,23.68-11.014,23.68-24.434 C835.561,236.411,825.073,225.749,811.881,225.728z"/> </g> </g> </svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots: false, 
            arrows: true
          }
        }
      ]
    });

  }

  function slideProductDetail() {
    $('.js_prod_main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dot: false,
      fade: false,
      infinite: false,
      
      asNavFor: '.js_prod_sub'
    });
    $('.js_prod_sub').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.js_prod_main',
      dots: false,
      arrows: true,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      focusOnSelect: true,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            vertical: true,
            infinite: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            vertical: true,
            infinite: true,
          }
        },

        {
          breakpoint: 575,
          settings: {
            vertical: false,
            infinite: false,
          }
        }
      ]
    });

  }

  function slideProductDetail2() {
    let silickProdMain2 = $('.js_prod_main2').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dot: false,
      fade: false,
      
      infinite: false,
      asNavFor: $(window).width() > 990 ? '.js_prod_sub2' : '',
      lazyLoad:'ondemand'
    });
    let silickProdSub2 = null
    if ($(window).width() > 990 ) {
      $('.js_prod_sub2').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.js_prod_main2',
      dots: false,
      arrows: true,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      infinite: false,
      focusOnSelect: true,
      lazyLoad:'ondemand',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            infinite: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            infinite: false,
          }
        },

        {
          breakpoint: 575,
          settings: {
            infinite: false,
          }
        }
      ]
    });
    }
    if("function" == typeof PhotoSwipeLightbox){
      var lightbox = new PhotoSwipeLightbox({
          gallery: '.product-gallery-img-list',
          children: 'a',
          // dynamic import is not supported in UMD version
          pswpModule: PhotoSwipe
      });
      lightbox.init();
    }
    if ($(window).width() < 990 ) {
        silickProdMain2 && silickProdMain2.on("afterChange", function(e, slick, currentSlide){
          const imgIndex = $('.js_prod_main2 .slick-track .slick-current').attr('img-index');
          const prodSubDom = $('.js_prod_sub2 .engoj-nav-item');
          const { imgUrl, dimensionIndex } =  prodSubMethod(prodSubDom, imgIndex)
          const { indexImg } =  isHaveDimensionMethod($('.js_prod_sub2 .engoj-nav-item'))
          if (indexImg) {
             const curimgIndex = imgIndex ? Number(imgIndex) : 0
             dimensionMethod(imgUrl, dimensionIndex, curimgIndex+1);
          } else {
             dimensionMethod(imgUrl, dimensionIndex, imgIndex);
          }
        })
  
        $(document).on('click', '.js_prod_sub2 .engoj-nav-item', function(e) {
          const imgIndex = $(this).attr('img-index');
          const imgUrl =  $(this).find('img').attr('src');
          const dimensionIndex = $(this).attr('dimension_index');
          const curClass = $('.content-page-detail .gallery-control .custom-indicator .custom-indicator-selector').attr('class');
          $(this).find('img').css('border', '1px solid #f4841a');
          $(this).siblings().find('img').css('border', 'none');
          const { indexImg } =  isHaveDimensionMethod($('.js_prod_sub2 .engoj-nav-item'))
          if (indexImg) {
            silickProdMain2.slick('slickGoTo', Number(imgIndex));
            //dimensionMethod(imgUrl, dimensionIndex, Number(imgIndex)+1);
          } else {
            silickProdMain2.slick('slickGoTo', Number(imgIndex)-1);
            //dimensionMethod(imgUrl, dimensionIndex, imgIndex);
          }
      })
    }

    function isHaveDimensionMethod(dom) { // 是否有配置dimension数据
       let indexImg = ''
       let dimensionIndex = ''
       let curIndex = 0
       for(let i = 0; i < dom.length; i ++) {
          const urlData = $(dom[i]).find('img').attr('data-src');
          if (urlData.indexOf('Dimension') > -1 && curIndex === 0) {
            indexImg = $(dom[i]).attr('img-index');
            dimensionIndex = $(dom[i]).attr('dimension_index');
            curIndex++
          }
       }
       return {
         indexImg: indexImg,
         dimensionIndex: dimensionIndex
       }
    }
    function prodSubMethod(prodSubDom, imgIndex) {
      let imgUrl = ''
      let dimensionIndex = ''
      for (let i = 0; i < prodSubDom.length; i++) {
        const curIndex = $(prodSubDom[i]).attr('img-index');
        const imgDom = $(prodSubDom[i]).find('img');
        if (curIndex == imgIndex) {
          imgUrl = imgDom.attr('src');
          dimensionIndex = $(prodSubDom[i]).attr('dimension_index');
          imgDom.css('border', '1px solid #f4841a')
        } else {
          imgDom.css('border', 'none')
        }
      }
      return {
        imgUrl: imgUrl,
        dimensionIndex: dimensionIndex
      }
    }
    
    function dimensionMethod(imgUrl, dimensionIndex, imgIndex) {
      if (imgUrl.indexOf('Dimension') > -1) {
       $('.content-page-detail .gallery-control .custom-indicator .custom-indicator-selector-num').text(dimensionIndex);
       $('.content-page-detail .gallery-control .custom-indicator-active em').hide();
       $('.content-page-detail .gallery-control .custom-indicator-selector em').show()
       $('.content-page-detail .gallery-control .custom-indicator-selector').addClass('custom-indicator-active1').siblings().removeClass('custom-indicator-active1');
     } else {
       $('.content-page-detail .gallery-control .custom-indicator-active').addClass('custom-indicator-active1').siblings().removeClass('custom-indicator-active1');
       $('.content-page-detail .gallery-control .custom-indicator-active em').show()
       $('.content-page-detail .gallery-control .custom-indicator-selector em').hide();
     }
     $('.content-page-detail .gallery-control .custom-indicator .custom-indicator-active i').text(imgIndex);
    }

    $(document).on('click', '.content-page-detail .gallery-control .custom-indicator-selector', function(e) {
       const dom = $('.js_prod_sub2 .slick-track .engoj-nav-item');
       $(this).addClass('custom-indicator-active1').siblings().removeClass('custom-indicator-active1');
       let indexImg = ''
       let dimensionIndex = ''
       let curIndex = 0
       for(let i = 0; i < dom.length; i ++) {
          const urlData = $(dom[i]).find('img').attr('data-src');
          if (urlData.indexOf('Dimension') > -1 && curIndex === 0) {
            indexImg = $(dom[i]).attr('img-index');
            dimensionIndex = $(dom[i]).attr('dimension_index');
            curIndex++
          }
       }
       if (indexImg) { // 没有配置
         silickProdSub2.slick('slickGoTo', Number(indexImg)-1);
         $('.content-page-detail .gallery-control .custom-indicator .custom-indicator-selector-num').text(dimensionIndex);
         $('.content-page-detail .gallery-control .custom-indicator-active em').hide();
         $('.content-page-detail .gallery-control .custom-indicator-selector em').show();
       } else {
         $('.content-page-detail .gallery-control .custom-indicator .custom-indicator-selector-num').text(0);
         $('.content-page-detail .gallery-control .custom-indicator-active em').hide()
       }
    })
    $(document).on('click', '.content-page-detail .gallery-control .custom-indicator-active', function(e) {
       $(this).addClass('custom-indicator-active1').siblings().removeClass('custom-indicator-active1');
       $('.content-page-detail .gallery-control .custom-indicator .custom-indicator-selector-num').text('');
       $('.content-page-detail .gallery-control .custom-indicator-active em').show()
       silickProdSub2.slick('slickGoTo', 0);
    })
  }
  function slideProductDetail3() {
    $('.js_prod_main3').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dot: false,
      fade: true,
      
      infinite: false,
      asNavFor: '.js_prod_sub3'
    });
    $('.js_prod_sub3').slick({
      slidesToShow: 15,
      slidesToScroll: 1,
      asNavFor: '.js_prod_main3',
      dots: false,
      arrows: true,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      infinite: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            infinite: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            infinite: false,
            slidesToShow: 5,
          }
        },

        {
          breakpoint: 575,
          settings: {
            infinite: false,
            slidesToShow: 4,
          }
        }
      ]
    });
  }
  function slideProductDetailBottom() {
    $('.js_prod_main_bot').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dot: false,
      fade: false,
      
      infinite: false
    });


  }

  function sizeGuide(){
    $('.btn_size_guide').on('click',function(){
      $('.content_size_guide').addClass('active');
      $('.layout_size_guide').addClass('active');
      $('.js_sticky').removeClass('sticky_content');
      $('.overlay').addClass('active');
      $('.question-form-page').hide();
      $('.delivery_return').hide();
    });
    $('.overlay').on('click',function(){
      $('.content_size_guide').removeClass('active');
      $('.layout_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.question-form-page').show();
      $('.delivery_return').show();
    });
    $('.close_size_guide').on('click',function(){
      $('.js_sticky').addClass('sticky_content');
      $('.content_size_guide').removeClass('active');
      $('.layout_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.question-form-page').show();
      $('.delivery_return').show();
    });
  }
  
   function deliveryReturn(){
    $('.btn_delivery').on('click',function(){
      $('.content_size_guide').addClass('active');
      $('.js_sticky').removeClass('sticky_content');
      $('.overlay').addClass('active');
      $('.size_guide').hide();
      $('.question-form-page').hide();
    });
    $('.overlay').on('click',function(){
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.size_guide').show();
      $('.question-form-page').show();
    });
    $('.close_size_guide').on('click',function(){
      $('.js_sticky').addClass('sticky_content');
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.size_guide').show();
      $('.question-form-page').show();
    });
  }
  
  function askQuestion(){
    $('.btn_question').on('click',function(){
      $('.content_size_guide').addClass('active');
      $('.layout_size_guide').addClass('layout_question');
      $('.js_sticky').removeClass('sticky_content');
      $('.overlay').addClass('active');
      $('.size_guide').hide();
      $('.delivery_return').hide();
      if($('.prod_product_detail .engoj-variant-sku').length > 0){
        var variant_sku_str = $('.prod_product_detail .engoj-variant-sku').html();
        if($('#contact-form-block #contact-sku-str').length > 0){
            $('#contact-sku-str span').html(variant_sku_str);
            $('#contact-sku-str #contactFormSku').val(variant_sku_str);
        }else{
            var variant_sku_html = '<div id="contact-sku-str" class="col-sm-12">SKU: <span>'+variant_sku_str+'</span>';
            variant_sku_html = variant_sku_html + '<input value="'+variant_sku_str+'" type="hidden" id="contactFormSku" name="contact[sku]"></div>';
            $('#contact-form-block').append(variant_sku_html);
        }
      }
    });
    $('.overlay').on('click',function(){
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.layout_size_guide').removeClass('layout_question');
      $('.size_guide').show();
      $('.delivery_return').show();
    });
    $('.close_size_guide').on('click',function(){
      $('.js_sticky').addClass('sticky_content');
      $('.content_size_guide').removeClass('active');
      $('.overlay').removeClass('active');
      $('.layout_size_guide').removeClass('layout_question');
      $('.size_guide').show();
      $('.delivery_return').show();
    });
  }

  function sortLayout() {
    if ($(window).width() < 1300) {
      $('.size_3').addClass('active');
      $('.size_4').removeClass('active');
      $('.size_5').addClass('d-none');
    }

    if ($(window).width() >= 1300) {
      $('.size_3').removeClass('active');
      $('.size_4').addClass('active');
      $('.size_5').removeClass('d-none');
    }

    if ($(window).width() < 768) {
      $('.size_2').addClass('active');
      $('.size_4').removeClass('active');
      $('.size_5').addClass('d-none');
      $('.size_4').addClass('d-none');
      $('.size_3').addClass('d-none');
    }
    $(window).resize(function(){
      if ($(window).width() < 1300) {
        $('.size_3').addClass('active');
        $('.size_4').removeClass('active');
        $('.size_5').addClass('d-none');
      }

      if ($(window).width() >= 1300) {
        $('.size_3').removeClass('active');
        $('.size_4').addClass('active');
        $('.size_5').removeClass('d-none');
      }

      if ($(window).width() < 768) {
        $('.size_2').addClass('active');
        $('.size_4').removeClass('active');
        $('.size_5').addClass('d-none');
        $('.size_4').addClass('d-none');
        $('.size_3').addClass('d-none');
      }
    });

    $('.size_5').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
      $('.js_size_prod').addClass('col-lg-2dot4');
      $(this).addClass('active');
      $('.size_6').removeClass('active');
      $('.size_4').removeClass('active');
      $('.size_3').removeClass('active');
    });
    $('.size_4').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
      $('.js_size_prod').addClass('col-md-3');
      $(this).addClass('active');
      $('.size_5').removeClass('active');
      $('.size_6').removeClass('active');
      $('.size_3').removeClass('active');
      $('.size_2').removeClass('active');
    });
    $('.size_3').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
      $('.js_size_prod').addClass('col-md-4');
      $(this).addClass('active');
      $('.size_5').removeClass('active');
      $('.size_4').removeClass('active');
      $('.size_6').removeClass('active');
      $('.size_2').removeClass('active');
    });
    $('.size_2').on('click', function() {
      $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12 col-12');
      $('.js_size_prod').addClass('col-6');
      $(this).addClass('active');
      $('.size_3').removeClass('active');
      $('.size_4').removeClass('active');
      $('.size_1').removeClass('active');
    });
  }

  function changeProdListGrid(){
    $('.prod_grid').on('click',function(){
      $('.product-grid-view').addClass('active');
      $('.product-list-view').removeClass('active');
      $(this).addClass('active');
      $('.prod_list').removeClass('active');
      $('.prod_per').removeClass('active');

    });
    $('.prod_list').on('click',function(){
      $('.product-grid-view').removeClass('active');
      $('.product-list-view').addClass('active');
      $(this).addClass('active');
      $('.prod_grid').removeClass('active');
      $('.prod_per').addClass('active');
    });
  }

  function FilterPushLeft(){
    if ($(window).width() > 990) {
      $('.js_filter').on('click',function(){
        $('.filter-to-left').toggleClass('active');
        $('.bg-minicart').addClass('active'); 
        $('.mobile-clear-btns').css('left', '30px');
        $('body').addClass('cartover');
      });
    } else {
      $(document).on('touchend', '.js_filter', function(event) {
        //$('.filter-to-left').toggleClass('active');
        $('.filter-to-left').addClass('active');
        $('.bg-minicart').addClass('active'); 
        $('.mobile-clear-btns').css('left', '30px');
        $('body').addClass('cartover');
        event.preventDefault();
      })
    }
  
    $('.close_filter').on('click',function(){
      $('.filter-to-left').removeClass('active');
      $('.mobile-clear-btns').css('left', '-100%');
      if(window.location.pathname.indexOf("/cart")>-1){
        return 
      }
      $('.bg-minicart').removeClass('active'); 
      $('body').removeClass('cartover');
    });
    $('.bg-minicart').on('click',function(){
      $('.filter-to-left').removeClass('active');
      //if(window.location.pathname.indexOf("/cart")>-1){
        return 
      //}
      $('.bg-minicart').removeClass('active');
      $('body').removeClass('cartover');
    });
  }

  function heighthdSticky(){
    
    $('.detail-info').css({'top':function(){
      return $('.js_height_hd').outerHeight() + 10;
    }})
    
    $('.js-slide-item').css({'padding-top':function(){
      return $('.js_height_hd').outerHeight();
    }})
  }

  function listcollection(){
    $('.js_list_col').slick({
      dots: false,
      arrows:true,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 5,
      slidesToScroll: 1,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },

        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

  }

  function jsDScollectionV1(){
    $('.js_ds_collectionv1').slick({
      dots: false,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots: false, 
            arrows: false
          }
        }
      ]
    });

  }
  
  function jsrelatepost(){
    $('.js_relate_post').slick({
      dots: true,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 3,
      slidesToScroll: 2,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots: false, 
            arrows: true
          }
        }
      ]
    });

  }

  function jscolbreacrumb(){
    $('.js_col_breacrumb').slick({
      dots: false,
      arrows:true,
      infinite: true,
      speed: 300,
      autoplay:false,
      slidesToShow: 6,
      slidesToScroll: 1,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });

  }

  function jsslidelookbook(){
    $('.js_slide_lookbook').slick({
      dots: false,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 1,
      slidesToScroll: 1,
      
    });

  }

  function jschangeborder(){
    $('.js_change_border').on('click',function(){
      $('.js_change_border').parent().find('.js_change_border').removeClass('active')
      $(this).addClass('active');

    });
  }
  
  function jschangethumbnail(){
    $('.js_change_thumbnail').on('click',function(){
      $('.js_change_thumbnail').parent().find('.js_change_thumbnail').removeClass('active')
      $(this).addClass('active');
      
    });
  }
  
  function testimonialV1() {
    $('.js-testimonial-v1').slick({
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: true,
      prevArrow: '<button class="testimonial-arrow arrow-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button class="testimonial-arrow arrow-next"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  function testimonialV2() {
    $('.js-testimonial-v2').slick({
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: true,
      prevArrow: '<button class="testimonial-arrow arrow-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button class="testimonial-arrow arrow-next"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
    });
  }

  function js_prod_menu() {

    $('.js_prod_menu').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: false,
      prevArrow: '<button type="button" class="slick-brand-prev fa fa-angle-left"></button>',
      nextArrow: '<button type="button" class="slick-brand-next fa fa-angle-right"></button>',
      vertical: true,
      
      verticalSwiping: true,
      focusOnSelect: true
    });

  }

  function productnewh5(){
    $('.slick_product_new-h5').slick({
      arrows: true,
      infinite: false,
      dots: false ,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 2000,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            arrows: true,
            infinite: false,
            dots: false ,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            arrows: true,
            infinite: false,
            dots: false ,
          }
        }
      ]
    });
  } 
  

  function js_draw_filter(){
    $('.js-draw-filter-btn').on('click',function(){
      $(this).addClass('js-draw-filter-open');
      $(this).removeClass('js-draw-filter-btn');
      $('.js-draw-filter').removeClass('draw_filter').addClass('col-lg-3');
      $('.js-draw-filter-2').removeClass('col-lg-12').addClass('col-lg-9');
      if ( $('.collection-filter-result').children().length > 1) {
        $(".collection-filter-result").css('display', 'flex');
      }
      $('.js-draw-filter-open').on('click',function(){
        $(this).addClass('js-draw-filter-btn');
        $(this).removeClass('js-draw-filter-open');
        $('.js-draw-filter').addClass('draw_filter').removeClass('col-lg-3');
        $('.js-draw-filter-2').addClass('col-lg-12').removeClass('col-lg-9');
      })

      setTimeout(function(){
        js_draw_filter()
      })
    })
  } 
  
  function jstoolbarScroll(){
    $(window).scroll(function () {
      spliceElementMethod(1)
      if ($(this).scrollTop() > 130) {
        $('.js-toolbar-icon').addClass("active");
      } else {
        $('.js-toolbar-icon').removeClass("active");
      };
    });
  }

  function jsProdDetails_gallery(){
    $('.js_prod_detail_gallery').slick({
      dots: true,
      arrows:true,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 3,
      slidesToScroll: 1,
      
      nextArrow:'<button type="button" class="next-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> <g id="Forma_1"> <path fill-rule="evenodd" clip-rule="evenodd" d="M834.107,232.981L618.365,17.218c-9.3-9.624-24.779-9.624-34.405,0 c-9.299,9.303-9.299,24.778,0,34.059l174.447,174.441H182.759c-13.42,0.021-24.086,10.686-24.086,24.108 c0,13.417,10.666,24.436,24.086,24.436h575.648L583.96,448.375c-9.299,9.63-9.299,25.12,0,34.401 c9.626,9.632,25.128,9.632,34.405,0l215.742-215.742C843.733,257.739,843.733,242.263,834.107,232.981z"/> </g> </g> <g id="Forma_1_copy_1_"> </g> </svg></button>',
      prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> </g> <g id="Forma_1_copy_1_"> <g id="Forma_1_copy"> <path fill-rule="evenodd" clip-rule="evenodd" d="M811.881,225.728H245.96L417.457,51.275c9.143-9.269,9.143-24.751,0-34.055 c-9.463-9.627-24.679-9.627-33.821,0l-212.1,215.762c-9.462,9.282-9.462,24.765,0,34.054l212.1,215.742 c9.12,9.627,24.358,9.627,33.821,0c9.143-9.276,9.143-24.772,0-34.4L245.96,274.265h565.921c13.192,0,23.68-11.014,23.68-24.434 C835.561,236.411,825.073,225.749,811.881,225.728z"/> </g> </g> </svg></button>',
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

  }
  
  function checkclickcol(){
    $('.js-check-click-col').on('click', function(){
      $(this).toggleClass('active');
    })
  }
  
  function js_product_flashsale(){
    $('.js-product-flash-sale').slick({
      arrows: true,
      infinite: true,
      dots: false ,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right" aria-hidden="true"></i></button>', 
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  function jsbannerv1(){
    $('.js_banner_v1').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 600,
      autoplay:false,
      slidesToShow: 3,
      slidesToScroll: 1,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  
  function product_v1() { 
    $('.js_section_product').slick({
      slidesToShow: 3,
      slidesToScroll: 2,
      speed: 900,
      autoplay: false,
      autoplaySpeed: 3500,
      dots: true,
      arrows: false,
      
      prevArrow:'<button type="button" class="prev-slide slick-arrow"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide slick-arrow"><i class="fa fa-angle-right"></i></button>', 
      responsive: [
        {
          breakpoint:920,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint:768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
          }
        }
      ]
    });
  }
  
   function product_best_seller() { 
    $('.js_best_seller').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      speed: 900,
      autoplay: false,
      autoplaySpeed: 3500,
      dots: true,
      arrows: false,
      
      prevArrow:'<button type="button" class="prev-slide slick-arrow"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide slick-arrow"><i class="fa fa-angle-right"></i></button>', 
      responsive: [
        {
          breakpoint:768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
          }
        }
      ]
    });
  }
  
  function servicePage(){
    $('.slickjs-services-v1').slick({
      dots: false,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 3,
      slidesToScroll: 1,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 757,
          settings: {
            slidesToShow: 1,
            arrows:false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            arrows:false,
          }
        }
      ]
    });

  }

  function js_menu_horiontal() {  
    $('.bg-mobile-menu').on('click',function(){
      $('body').removeClass('active')
      $(this).removeClass('active')
      $('.tab-menu-mobile ul').removeClass('active, .active2')
      $('.tab-menu-1').addClass('active')
    })
    $('.js-link-click').each(function(){
      $(this).on('click',function(e){
        e.preventDefault()
        var id = $(this).attr('data-click')
        $(this).parents('.active').addClass('active2')
        var link = $('[data-open="'+id+'"]')
        link.addClass('active')
      })
    })
    $('.js-header-mobile-menu').each(function(){
      $(this).on('click',function(){
        var $link = $('.tab-menu-mobile').find('.active2').eq(-1)
        $(this).parent().removeClass('active')
        $link.removeClass('active2')
      })
    })
  }

  function blogV2(){
    $('.js-blog-v2').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      
      prevArrow: '<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow: '<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            dots: false
          }
        }, 
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false
          }
        }]
    });
  }

  function collectionV1() {
    $('.js-collection-v1').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: false,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrow: true,
            dots: false
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            dots: false
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: true
          }
        }
      ]
    });
  }
  function collectionV2() {
    $('.js-collection-v2').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: false,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            dots: false
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            autoplay: true
          }
        }
      ]
    });
  }
  function Collectionv3() {
    $('.js-collection-v3').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      autoplay: false,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrow: false,
            dots: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: false
          }
        }
      ]
    });
  }

  function brandv1() {
    $('.jsbrand_list_v1').slick({
      dots: false,
      arrows:false,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 1,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }
  function productV5() {
    $('.js_product_v5').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      
      prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"> <g> <g> <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8 c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712 L143.492,221.863z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
      nextArrow:'<button type="button" class="next-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M390.965,241.681l-242.001-236c-7.907-7.711-20.57-7.553-28.282,0.355c-7.712,7.908-7.553,20.57,0.355,28.282L348.353,256 L121.037,477.681c-7.908,7.712-8.067,20.374-0.355,28.282c7.713,7.91,20.375,8.065,28.281,0.355l242.001-236 C394.823,266.555,397,261.391,397,256S394.823,245.445,390.965,241.681z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>', 
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

  }
  function productV6(){
    $('.js_product_v6').slick({
      dots: true,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:true,
      slidesToShow: 2,
      slidesToScroll: 1,
      
      prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve"> <g> <g> <path d="M143.492,221.863L336.226,29.129c6.663-6.664,6.663-17.468,0-24.132c-6.665-6.662-17.468-6.662-24.132,0l-204.8,204.8 c-6.662,6.664-6.662,17.468,0,24.132l204.8,204.8c6.78,6.548,17.584,6.36,24.132-0.42c6.387-6.614,6.387-17.099,0-23.712 L143.492,221.863z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
      nextArrow:'<button type="button" class="next-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <g> <path d="M390.965,241.681l-242.001-236c-7.907-7.711-20.57-7.553-28.282,0.355c-7.712,7.908-7.553,20.57,0.355,28.282L348.353,256 L121.037,477.681c-7.908,7.712-8.067,20.374-0.355,28.282c7.713,7.91,20.375,8.065,28.281,0.355l242.001-236 C394.823,266.555,397,261.391,397,256S394.823,245.445,390.965,241.681z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>', 
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

  }
  function productCountdown() { 
    $('.js_section_product_countdown').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 900,
      autoplay: false,
      autoplaySpeed: 3500,
      dots: true,
      arrows: false,
      
      prevArrow:'<button type="button" class="prev-slide slick-arrow"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide slick-arrow"><i class="fa fa-angle-right"></i></button>', 
      responsive: [
        {
          breakpoint:768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint:768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          }
        }
      ]
    });
  }
  function serviceV1() {
    $('.js-service-v1').slick({
      dots: false,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:true,
      slidesToShow: 4,
      slidesToScroll: 1,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
  
  function servicev2(){
    $('.js-services-v2').slick({
      dots: false,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:true,
      slidesToShow: 3,
      slidesToScroll: 1,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
function slidebanner11(){
    $('.slick-side-1').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      dots: false,
      arrows: true,
      fade : true,
      adaptiveHeight: true,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            infinite: true,
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint:600,
          settings: {
            dots: true ,
            arrows: false,
          }
        }
      ]
    });
  }
  function slideshowV1(){
    $('.js-slideshow-v1').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      dots: true,
      arrows: false,
      fade : true,
      adaptiveHeight: true,
      
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-long-arrow-left"></i> </button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-long-arrow-right"></i></button>', 
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            infinite: true,
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            dots: true ,
            arrows: false
          }
        },
        {
          breakpoint:600,
          settings: {
            dots: true ,
            arrows: false,
          }
        }
      ]
    });
  }
  
  function slideshowV2(){
    $('.js-slideshow-v2').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3500,
      infinite: true,
      dots: true,
      arrows: false,
      prevArrow:'<button type="button" class="prev-slide"><svg class="qodef-rev-nav-left" xmlns="http://www.w3.org/2000/svg" width="39.376" height="39.376" viewBox="0 0 39.376 39.376"> <g id="arrow" transform="translate(20.377 38.669) rotate(-135)"> <path id="Path_4" data-name="Path 4" d="M0,0H26.818V26.869" transform="translate(0 0)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"></path> <line id="Line_1" data-name="Line 1" x1="25.621" y2="25.723" transform="translate(0.968 0.458)" fill="none" stroke="#fff" stroke-linejoin="bevel" stroke-width="2" style="isolation: isolate"></line> </g></svg></button>',
      nextArrow:'<button type="button" class="next-slide"><svg class="qodef-rev-nav-right" xmlns="http://www.w3.org/2000/svg" width="39.376" height="39.376" viewBox="0 0 39.376 39.376"> <g id="arrow" transform="translate(18.999 0.707) rotate(45)"> <path id="Path_4" data-name="Path 4" d="M0,0H26.818V26.869" transform="translate(0 0)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"></path> <line id="Line_1" data-name="Line 1" x1="25.621" y2="25.723" transform="translate(0.968 0.458)" fill="none" stroke="#fff" stroke-linejoin="bevel" stroke-width="2" style="isolation: isolate"></line> </g></svg></button>',
      fade: true
    });
  }

  function slideshowV3(){
    $('.js-slideshow-v3').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3500,
      dots: false,
      arrows: true,
      infinite: true,
      prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
      nextArrow:'<button type="button" class="next-slide"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
      fade: true
    });
  }

  function slideshowV4() {
    $('.js-slideshow-v4').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3500,
      dots: true,
      arrows: true,
      prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 490.787 490.787" style="enable-background:new 0 0 490.787 490.787;" xml:space="preserve"> <path style="fill:#F44336;" d="M362.671,490.787c-2.831,0.005-5.548-1.115-7.552-3.115L120.452,253.006 c-4.164-4.165-4.164-10.917,0-15.083L355.119,3.256c4.093-4.237,10.845-4.354,15.083-0.262c4.237,4.093,4.354,10.845,0.262,15.083 c-0.086,0.089-0.173,0.176-0.262,0.262L143.087,245.454l227.136,227.115c4.171,4.16,4.179,10.914,0.019,15.085 C368.236,489.664,365.511,490.792,362.671,490.787z"/> <path d="M362.671,490.787c-2.831,0.005-5.548-1.115-7.552-3.115L120.452,253.006c-4.164-4.165-4.164-10.917,0-15.083L355.119,3.256 c4.093-4.237,10.845-4.354,15.083-0.262c4.237,4.093,4.354,10.845,0.262,15.083c-0.086,0.089-0.173,0.176-0.262,0.262 L143.087,245.454l227.136,227.115c4.171,4.16,4.179,10.914,0.019,15.085C368.236,489.664,365.511,490.792,362.671,490.787z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
      nextArrow:'<button type="button" class="next-slide"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 490.8 490.8" style="enable-background:new 0 0 490.8 490.8;" xml:space="preserve"> <path style="fill:#F44336;" d="M135.685,3.128c-4.237-4.093-10.99-3.975-15.083,0.262c-3.992,4.134-3.992,10.687,0,14.82 l227.115,227.136L120.581,472.461c-4.237,4.093-4.354,10.845-0.262,15.083c4.093,4.237,10.845,4.354,15.083,0.262 c0.089-0.086,0.176-0.173,0.262-0.262l234.667-234.667c4.164-4.165,4.164-10.917,0-15.083L135.685,3.128z"/> <path d="M128.133,490.68c-5.891,0.011-10.675-4.757-10.686-10.648c-0.005-2.84,1.123-5.565,3.134-7.571l227.136-227.115 L120.581,18.232c-4.171-4.171-4.171-10.933,0-15.104c4.171-4.171,10.933-4.171,15.104,0l234.667,234.667 c4.164,4.165,4.164,10.917,0,15.083L135.685,487.544C133.685,489.551,130.967,490.68,128.133,490.68z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>', 
      fade: true, 
      responsive: [

        {
          breakpoint: 1200,
          settings: {
            infinite: true,
            dots: true 
          }
        },
        {
          breakpoint: 1024,
          settings: {
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            dots: true,
            arrows: false
          }
        }
      ]
    });
  }
  function slideshowV5(){
    $('.js-slideshow-v5').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3500,
      infinite: true,
      dots: true,
      arrows: false,
      prevArrow: '<button type="button" class="prev-slide"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
      nextArrow: '<button type="button" class="next-slide"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
      fade: true,
      responsive: [
        {
          breakpoint: 1800,
          settings: {
            infinite: true,
            dots: true,
            arrows: false
          }
        }, 
        {
          breakpoint: 1024,
          settings: {
            dots: false,
            arrows: true
          }
        }, 
        {
          breakpoint: 768,
          settings: {
            dots: false,
            arrows: true
          }
        }, 
        {
          breakpoint: 600,
          settings: {
            dots: false,
            arrows: true,
            autoplay: true
          }
        }
      ]
    });
  } 
  
  
  productV5();
  productV6();
  productCountdown();
  testimonialV1();
  testimonialV2();
  servicePage();
  serviceV1();
  servicev2();
  brandv1();
  slidebanner11()
  slideshowV1();
  slideshowV2();
  slideshowV3();
  slideshowV4();
  slideshowV5();
  collectionV1();
  collectionV2();
  Collectionv3();
  blogV1();
  blogV2();
  js_menu_horiontal();
  product_v1();
  product_best_seller();
  jsbannerv1();
  js_product_flashsale();
  checkclickcol();
  jsProdDetails_gallery();
  jstoolbarScroll();
  js_draw_filter();
  productnewh5();
  js_prod_menu();
  jschangethumbnail();
  jsProdDetails();
  listcollection()
  jsProdRelate();
  slideProductDetail();
  sizeGuide();
  deliveryReturn();
  askQuestion();
  slideProductDetailBottom();
  sortLayout();
  changeProdListGrid();
  FilterPushLeft();
  jsCollection();
  heighthdSticky();
  jsDScollectionV1();
  jsrelatepost();
  jscolbreacrumb();
  slideProductDetail2();
  
  jsslidelookbook();
  jschangeborder();
  instagramGalleryMethod();
  shopRoomMethod();
  clearFilterResultMethod();
  productActiveMethod();
  //productCoupupIcon();
  moveRightMethod();
  checkoutListMethod();
  addHrefAttrMethod();
  checkEmailValMethod();
  openMobileDialogMethod();
    // $(".content-page-detail").on("click",".img_thumb .slick-slide img",function(){
    //     if(window.innerWidth>768){
    //       $(".big_img_thumb").show()
    //       $("body").addClass("cartover")
    //       if(!$(".big_img_thumb").hasClass("big_img_thumb_none")){
    //         slideProductDetail3();
    //       }
    //       $('.js_prod_main3').slick ('slickGoTo', $(this).parent().index());
    //     }
    //   })
    //  $(".big_img_thumb .big_img_thumb_close").on("click",function(e){
    //   e.stopPropagation();
    //   $(this).parent().addClass('big_img_thumb_none').hide()
    //    $("body").removeClass("cartover")
    // })
});

jQuery(document).ready(function($) {
  $('[data-toggle="tooltip"]').tooltip(); 
});



jQuery(document).ready(function($) {
  "use strict";




  function promo(){
    $('.close_promo_topbar').on('click',function(){
      $('.promo_topbar').addClass("active");
    });
  }

  function search(){
    $('.js-search-destop').on('click', function() {
      $('.js-box-search').addClass('active');
      $('.bg_search_box').addClass('active');
      $('body').addClass('activedestop');
    });
    $('.js-drawer-close').on('click', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
    $('.bg_search_box').on('click', function() {
      $('.js-box-search').removeClass('active');
      $('.bg_search_box').removeClass('active');
      $('body').removeClass('activedestop');
    });
  }

  function minicart(){
    $('.js-call-minicart').on('click', function() {
      $('.js-minicart').addClass('active');
      $('.bg-minicart').addClass('active');
      $('body').addClass('cartover');
    });
    $('.close-mini-cart').on('click', function() {
      $('body').removeClass('cartover');
      if(window.location.pathname.indexOf("/cart")>-1){
        return 
      }
      $('.js-minicart').removeClass('active');
      $('.bg-minicart').removeClass('active');
    });
    $('.bg-minicart').on('click', function() {
      //if(window.location.pathname.indexOf("/cart")>-1){
        return 
      //}
      $('.js-minicart').removeClass('active');
      $('.bg-minicart').removeClass('active');
      $('body').removeClass('cartover');
    });

  }
  
  function miniaccount(){
    $('.js-call-account').on('click', function() {
      if($(this).attr("data-customer-id")!=''){
        window.location.href="/account"
        return 
      }
      $(this).toggleClass('active');
      $('.box_contentmenu').toggleClass('active');     
      $('.box_contentmenu_background').toggleClass('active');   
      $('body').addClass('activemenu_mobile');
      
      $(".tab_navar").removeClass('active');
      $(".tab_navar_right").addClass('active');
      
      $(".tab-pane:nth-child(1)").removeClass('show active');
      $(".tab-pane:nth-child(2)").addClass('show active');
      $('.form_register').hide();
      
    });
    
  }
  function clickshow(){
    $('.item-toggle-tab').on('click', function() {
      $(this).toggleClass('active');
    });
  }

  function menuhorizon() {

    $('.js-model_menu').on('click', function() {
      $('.js-horizon-menu').addClass('active');
      $('.js-bg-horizon-menu').addClass('active');
      $('body').addClass('cartover');
    });

    $('.js_close-menu-horizon').on('click', function() {
      $('.js-horizon-menu').removeClass('active');
      $('.js-bg-horizon-menu').removeClass('active');
      $('body').removeClass('cartover');
    });

    $('.js-bg-horizon-menu').on('click', function() {
      $('.js-horizon-menu').removeClass('active');
      $('.js-bg-horizon-menu').removeClass('active');
      $('body').removeClass('cartover');
    });

  }

  function jsmenuiconh(){
    $('.js_icon_horizon-menu').on( 'click', function() {
      $(this).parents().addClass('active');
    });
    $('.js-back').on( 'click', function() {
      $(this).parents().parents().find('.menu-horizon-list').removeClass('active');
    });       


  }

  function jscalllogindestop(){
    $('.js-call-popup-login').on( 'click', function() {
      $('.js-poup-login-destop').addClass('active');
      $('.js-bg-login-popup').addClass('active');
    });
    $('.js-eveland-close-login').on( 'click', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
    $('.js-bg-login-popup').on( 'click', function() {
      $('.js-poup-login-destop').removeClass('active');
      $('.js-bg-login-popup').removeClass('active');
    });
  }

  function jsBackLogin(){
    $('.jsCreate_account').on('click', function() {
      $('.form_register').show();
      $('.formlogin').hide();    
    });
    $('.tab_navar_right').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();    
    });

    $('.jsBack_login').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();        
    });
    $('.jsacount_destop').on('click', function() {
      $('.formlogin').show();
      $('.form_register').hide();        
    });
  }



  function jslogindestop(){
    $('.jsCreate_account').on('click', function() {
      $('.form_register-destop').show();
      $('.formlogin-destop').hide();    
    });
    $('.js-call-popup-login').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();    
    });

    $('.jsBack_login').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();        
    });
    $('.jsacount_destop').on('click', function() {
      $('.formlogin-destop').show();
      $('.form_register-destop').hide();        
    });
  }




  function mobilescroll() {
    var $nav = $(".jsmenumobile");
    $nav.removeClass('menu_mobilescroll');

    $(document).scroll(function() {

      $nav.toggleClass('menu_mobilescroll', $(this).scrollTop() > $nav.height());
    });
  }

  function menumobile() {
    $('.menuleft').on('click', function() {
      $(this).toggleClass('active');
      $('.box_contentmenu').toggleClass('active');     
      $('.box_contentmenu_background').toggleClass('active');   
      $('body').addClass('activemenu_mobile').addClass('cartover');      
    });
    $('.box_contentmenu_background').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
      $('body').removeClass('activemenu_mobile').removeClass('cartover');
    });
    $('.js-eveland-close').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
      $('body').removeClass('activemenu_mobile').removeClass('cartover');      
    });
  }

  function menutoolbar() {
    $('.btn_bar').on('click', function() {
      $(this).toggleClass('active');
      $('.box_contentmenu').toggleClass('active');     
      $('.box_contentmenu_background').toggleClass('active');     
    });
    $('.box_contentmenu_background').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
    });
    $('.js-eveland-close').on('click', function() {
      $(this).removeClass('active');
      $('.box_contentmenu').removeClass('active');
      $('.menuleft').removeClass('active');
      $('.box_contentmenu_background').removeClass('active');
    });
  };




  function popup(){
    $('.jsclosepoup').on('click', function() {
      $('.jsengo_popup').hide();
    });
  }
  function cookiepopup(){
    productCoupupIcon();
    if (!jQuery.cookie('success_pop_newletter') && (!jQuery.cookie('brilliant_pop_newletter') || jQuery.cookie('brilliant_pop_newletter') == null || jQuery.cookie('brilliant_pop_newletter') == 0 || jQuery.cookie('brilliant_pop_newletter') == undefined)) {    
        $(window).on('load', function(){
          setTimeout( function(){ 
            $('.jsengo_popup').show();
          }, 5 * 1000);
          jQuery('.jsclosepoup').click(function(e) {
            e.preventDefault();
            jQuery('.jsengo_popup').hide(); 
            $('.sub-coupup_icon_pc').removeClass('hide');
            //jQuery.cookie('brilliant_pop_newletter', '1', {expires: 1, path:'/', domain: '' });                                        });
          });
        });
        jQuery.cookie('brilliant_pop_newletter', '1', {expires: 1, path:'/', domain: '' });  
      } else {
        //$('.jsengo_popup').remove();
    }
  }

  // Scroll to TOP
  function totop(){
    var back_to_top = $('#back-to-top');
    if (back_to_top.length) {
      var scrollTrigger = 100, // px
          backToTop = function() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > scrollTrigger) {
              back_to_top.addClass('show');
            } else {
              back_to_top.removeClass('show');
            }
          };
      $(window).on('scroll', function() {
        backToTop();
        judgemeProductUrlChange();
      });
      back_to_top.on('click', function(e) {
        e.preventDefault();
        $('html,body').animate({
          scrollTop: 0
        }, 700);
      });
    }
    judgemeProductUrlChange();
  }


  function popup2(){
    $('.jsclose_cookie').on('click', function() {
      $('.jscookie_popup').addClass('d-none');

    });
  }

  function jsmenu_fullwidth(){
    var top = $('.js_height_hd').offset();
    var height = $('.js_height_hd').outerHeight();
    $('.js-full-width').css({'top' : top.top + height - 25 ,'position' : 'fixed' , 'left' :' 0' , 'right' : '0', 'width' : '100%' })

    $(window).scroll(function() {
      var height = $('.js_height_hd').outerHeight();
      if ($(window).scrollTop() >= height){      
        $('.js-full-width').css({'top' : height - 25 })
      }
      else{
        $('.js-full-width').css({'top' : top.top + height - 25  })
      }     
    });
  }
  
  function cookiepopup2() {
    if (!jQuery.cookie('cookie_popup') || jQuery.cookie('cookie_popup') == null) {    
      $(window).on('load', function(){
        //setTimeout($('.jscookie_popup').show(), 300 * 1000);
        jQuery('.jsclose_cookie').click(function(e) {
          e.preventDefault();
          jQuery('.jscookie_popup').hide(); 
          jQuery.cookie('cookie_popup', '1', {expires: 7, path:'/', domain: '' });
                                             });
        });
      } else {
         $('.jscookie_popup').remove();
    }
  }

  
  jsmenu_fullwidth();
  totop();
  jslogindestop();
  jscalllogindestop();
  popup();
  cookiepopup();
  popup2();
  cookiepopup2();
  menumobile();
  jsBackLogin();
  mobilescroll();
  menutoolbar();
  jsmenuiconh();
  menuhorizon();
  minicart();
  miniaccount();
  clickshow();
  search();
  promo();

});

      
      $(document).on("change", ".engoj-agree", function() {
        var input_is_checked = $(".engoj-agree"), 
            btn_dynamic_checkout = $(".more_info").find(".js-button-checkout");
        input_is_checked.is(":checked") ? btn_dynamic_checkout.removeClass("btn-disabled") : btn_dynamic_checkout.addClass("btn-disabled");
      });

      ///////ZOOM IMAGE

      jQuery(document).ready(function( $ ) {


        (function ($) {
          var defaults = {
            url: false,
            callback: false,
            target: false,
            duration: 120,
            on: 'mouseover', // other options: grab, click, toggle
            touch: true, // enables a touch fallback
            onZoomIn: false,
            onZoomOut: false,
            magnify: 0.9
          };

          // Core Zoom Logic, independent of event listeners.
          $.zoom = function(target, source, img, magnify) {
            var targetHeight,
                targetWidth,
                sourceHeight,
                sourceWidth,
                xRatio,
                yRatio,
                offset,
                $target = $(target),
                position = $target.css('position'),
                $source = $(source);

            // The parent element needs positioning so that the zoomed element can be correctly positioned within.
            target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
            target.style.overflow = 'hidden';
            img.style.width = img.style.height = '';

            $(img)
            .addClass('zoomImg engoj_img_main')
            .css({
              position: 'absolute',
              top: 0,
              left: 0,
              opacity: 0,
              width: img.width * magnify,
              height: img.height * magnify,
              border: 'none',
              maxWidth: 'none',
              maxHeight: 'none'
            })
            .appendTo(target);

            return {
              init: function() {
                targetWidth = $target.outerWidth();
                targetHeight = $target.outerHeight();

                if (source === target) {
                  sourceWidth = targetWidth;
                  sourceHeight = targetHeight;
                } else {
                  sourceWidth = $source.outerWidth();
                  sourceHeight = $source.outerHeight();
                }

                xRatio = (img.width - targetWidth) / sourceWidth;
                yRatio = (img.height - targetHeight) / sourceHeight;

                offset = $source.offset();
              },
              move: function (e) {
                var left = (e.pageX - offset.left),
                    top = (e.pageY - offset.top);

                top = Math.max(Math.min(top, sourceHeight), 0);
                left = Math.max(Math.min(left, sourceWidth), 0);

                img.style.left = (left * -xRatio) + 'px';
                img.style.top = (top * -yRatio) + 'px';
              }
            };
          };

          $.fn.zoom = function (options) {
            return this.each(function () {
              var
              settings = $.extend({}, defaults, options || {}),
                  //target will display the zoomed image
                  target = settings.target && $(settings.target)[0] || this,
                  //source will provide zoom location info (thumbnail)
                  source = this,
                  $source = $(source),
                  img = document.createElement('img'),
                  $img = $(img),
                  mousemove = 'mousemove.zoom',
                  clicked = false,
                  touched = false;

              // If a url wasn't specified, look for an image element.
              if (!settings.url) {
                var srcElement = source.querySelector('img');
                if (srcElement) {
                  settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
                }
                if (!settings.url) {
                  return;
                }
              }

              $source.one('zoom.destroy', function(position, overflow){
                $source.off(".zoom");
                target.style.position = position;
                target.style.overflow = overflow;
                img.onload = null;
                $img.remove();
              }.bind(this, target.style.position, target.style.overflow));

              img.onload = function () {
                var zoom = $.zoom(target, source, img, settings.magnify);

                function start(e) {
                  zoom.init();
                  zoom.move(e);

                  // Skip the fade-in for IE8 and lower since it chokes on fading-in
                  // and changing position based on mousemovement at the same time.
                  $img.stop()
                  .fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
                }

                function stop() {
                  $img.stop()
                  .fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
                }

                // Mouse events
                if (settings.on === 'grab') {
                  $source
                  .on('mousedown.zoom',
                      function (e) {
                    if (e.which === 1) {
                      $(document).one('mouseup.zoom',
                                      function () {
                        stop();

                        $(document).off(mousemove, zoom.move);
                      }
                                     );

                      start(e);

                      $(document).on(mousemove, zoom.move);

                      e.preventDefault();
                    }
                  }
                     );
                } else if (settings.on === 'click') {
                  $source.on('click.zoom',
                             function (e) {
                    if (clicked) {
                      // bubble the event up to the document to trigger the unbind.
                      return;
                    } else {
                      clicked = true;
                      start(e);
                      $(document).on(mousemove, zoom.move);
                      $(document).one('click.zoom',
                                      function () {
                        stop();
                        clicked = false;
                        $(document).off(mousemove, zoom.move);
                      }
                                     );
                      return false;
                    }
                  }
                            );
                } else if (settings.on === 'toggle') {
                  $source.on('click.zoom',
                             function (e) {
                    if (clicked) {
                      stop();
                    } else {
                      start(e);
                    }
                    clicked = !clicked;
                  }
                            );
                } else if (settings.on === 'mouseover') {
                  zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

                  $source
                  .on('mouseenter.zoom', start)
                  .on('mouseleave.zoom', stop)
                  .on(mousemove, zoom.move);
                }

                // Touch fallback
                if (settings.touch) {
                  $source
                  .on('touchstart.zoom', function (e) {
                e.preventDefault();
                if (touched) {
                  touched = false;
                  stop();
                } else {
                  touched = true;
                  start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
                }
              })
              .on('touchmove.zoom', function (e) {
                e.preventDefault();
                zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
              })
              .on('touchend.zoom', function (e) {
                e.preventDefault();
                if (touched) {
                  touched = false;
                  stop();
                }
              });
            }

            if ($.isFunction(settings.callback)) {
              settings.callback.call(img);
            }
          };

          img.setAttribute('role', 'presentation');
          img.alt = '';
          img.src = settings.url;
        });
      };

          $.fn.zoom.defaults = defaults;
        }(window.jQuery));
        $('.js-zoom-img').zoom();	


      });

      var btn_top = $('.back-to-top');

      $(window).scroll(function() {
        if ($(window).scrollTop() > 300) {
          btn_top.addClass('active');
        } else {
          btn_top.removeClass('active');
        }
      });

      btn_top.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop:0}, '300');
      });

      // $(document).on("click", ".section-newsletter-aboutv3 form", function(e) {
      //    e.preventDefault();
      //    $.ajax({
      //       type: "POST",
      //       url: $(this).attr('action'),
      //       cache: false,
      //       data: $(this).serialize(),
      //        success: function(data){
      //           alert("Thank's For Submitting Your Email");
      //        },
      //    })
      // });
 jQuery(document).ready(function($) {
   if($('.shop-home-page').length>0){
    var ajax_section_ids2 = [
        "template--23012615291171__featured_in_6wK6TU"
      ];
      ajaxGetSections(ajax_section_ids2.toString(),'#shopify-section-newsletter_about_v3',function(ele_obj, data){
        for(var section_i=0; section_i<ajax_section_ids2.length; section_i++){
          if((typeof data[ajax_section_ids2[section_i]]) != 'undefined' && data[ajax_section_ids2[section_i]]){
            $(ele_obj).before(data[ajax_section_ids2[section_i]]);
          }
        }
        blogV1();
      });
  }
    $('.jsengo_popup #contact_form .btn').click(function(){
      jQuery.cookie('scroll_pop_newletter', $(window).scrollTop(), {expires: 3600, path:'/', domain: '.sikaic.com' });
    });
    if(location.href.indexOf('customer_posted=true') !== -1){
      if($('.newsletter-subscribed-success').length >= 2 && location.href.indexOf('footer-newsletter') === -1){
        var scroll_pop_newletter = jQuery.cookie('scroll_pop_newletter');
        if (scroll_pop_newletter != undefined && scroll_pop_newletter != null || scroll_pop_newletter >= 100) {
          $('html').animate({scrollTop:scroll_pop_newletter},10) 
        }
        $('#footer-newsletter .newsletter-subscribed-success').hide();
        $('.newsletter-subscribed-success-popup').html($('#footer-newsletter .newsletter-subscribed-success').html()).show();
        setTimeout(() => {$('.newsletter-subscribed-success-popup').hide();$('#footer-newsletter .newsletter-subscribed-success').show()}, 10000);
      }
    }else if(location.href.indexOf('form_type=customer') !== -1){
      if($('.newsletter-subscribed-success').length >= 2 && location.href.indexOf('footer-newsletter') === -1){
        var scroll_pop_newletter = jQuery.cookie('scroll_pop_newletter');
        if (scroll_pop_newletter != undefined && scroll_pop_newletter != null || scroll_pop_newletter >= 100) {
          $('html').animate({scrollTop:scroll_pop_newletter},10) 
        }
        $('#footer-newsletter .newsletter-subscribed-success').hide();
        $('.newsletter-subscribed-success-popup').html($('#footer-newsletter .newsletter-subscribed-success').html()).show();
        setTimeout(() => {$('.newsletter-subscribed-success-popup').hide();}, 10000);
      }else{
        $('#footer-newsletter .newsletter-subscribed-success-error').show();
      }
    }
    var come_back_from_checkout = window.localStorage.getItem('checkoutUrl');
    window.localStorage.setItem('checkoutUrl', 0);
   
    if(come_back_from_checkout == '1' && location.href.indexOf('cart') === -1) {
       $('.js-call-minicart').click();
       //const isHaveDom = $('.js-minicart .enj-cartcount').text();
       //if (Number(isHaveDom) == 0) {
          setTimeout(function(){
             ajaxCart && ajaxCart.load(); //重新加载购物车
           }, 400)
       //}
       //ShopifyAPI.getCart(ajaxCart.cartUpdateCallback);
      
    }
    if(window.location.pathname.indexOf("/cart")>-1){
      $('.js-call-minicart').click();
    }
    $(document).on('click', '.coupon-copy-btn', function(e) {
        copyMethod($(this).attr('data'));
    });
    $('.header_top_bar_slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows:false,
    });
    $('.header_top_bar_slick_m').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows:false,
    });

    setTimeout(function () {
        let widthData = $('.jdgm-carousel__item-wrapper .jdgm-carousel-item').width()
        if (widthData > 0) {
          const widthDataStr = 'height:' +widthData+'px !important'
          const win1 = 'top: '+widthData/2 +'px'
          $('.jdgm-carousel__item-wrapper .jdgm-carousel-item').find('img').css('cssText', widthDataStr)
          $('.jdgm-carousel-wrapper .jdgm-carousel__left-arrow').css('cssText', win1)
          $('.jdgm-carousel-wrapper .jdgm-carousel__right-arrow').css('cssText', win1)
        }
    }, 500);
   $('.instagram_product_handle').each(function() {
      var product_handle_str = $(this).attr('data');
      var product_info = getProductInfo(product_handle_str, $(this), getInstagramProductInfo);
    });
   $('.new-product-sign').each(function() {
      var product_handle_str = $(this).attr('product_handle');
      var product_info = getProductInfo(product_handle_str, $(this), getShopByRoomProductInfo);
    });
   if($('#related-product-new').length){
        var related_product_new = $('#related-product-new');
        var related_product_handle = related_product_new.attr('product_handle');
        var related_product_handle_arr = related_product_handle.split(',');
        $.ajax({
            url: '/?sections=section_instagram_gallery_page,section-shop-the-look&handles='+related_product_handle,
            type: 'GET',
            dataType: "json",
            cache: false,
            success: function(data) {
              /*instagram gallery*/
              var product_handle_contain = 0;
              if((typeof data.section_instagram_gallery_page) != 'undefined' && data.section_instagram_gallery_page){
                  for(var i=0; i<related_product_handle_arr.length; i++){
                      if(data.section_instagram_gallery_page.indexOf(related_product_handle_arr[i]) !== -1){
                        product_handle_contain = 1;
                      }
                  }
              }
              if(product_handle_contain == 1){
                var section_instagram_gallery_page = $(data.section_instagram_gallery_page);
                section_instagram_gallery_page.find('.section-instagram-gallery .instagram_gallery_title').html('Find #Sikaic In Media');
                var img_box_index = 0;
                section_instagram_gallery_page.find('.image-list .image-list-item').each(function(){
                    if(related_product_handle.indexOf($(this).attr('product_handle')) === -1){
                        $(this).remove();
                    }else{
                      $(this).find('.img-box').attr('index', ++img_box_index);
                    }
                });
                img_box_index = 0;
                section_instagram_gallery_page.find('.image-list-slick .img-box').each(function(){
                    if(related_product_handle.indexOf($(this).attr('product_handle')) === -1){
                        $(this).remove();
                    }else{
                      $(this).attr('index', ++img_box_index);
                    }
                });
                //related_product_new.before(section_instagram_gallery_page.html()); //详情页不需要该模块
                /*
                related_product_new.before(data.section_instagram_gallery_page);
                $('.section-instagram-gallery .instagram_gallery_title').html('Find #Sikaic in Instagram');
                var img_box_index = 0;
                $('.image-list .image-list-item').each(function(){
                    if(related_product_handle.indexOf($(this).attr('product_handle')) === -1){
                        $(this).remove();
                    }else{
                      $(this).find('.img-box').attr('index', ++img_box_index);
                    }
                });
                img_box_index = 0;
                $('.image-list-slick .img-box').each(function(){
                    if(related_product_handle.indexOf($(this).attr('product_handle')) === -1){
                        $(this).remove();
                    }else{
                      $(this).attr('index', ++img_box_index);
                    }
                });
                */
                //instagramGalleryMethod();
                $('.instagram_product_handle').each(function() {
                  var product_handle_str = $(this).attr('data');
                  var product_info = getProductInfo(product_handle_str, $(this), getInstagramProductInfo);
                });
              }
              /*product page room ideas*/
              var product_handle_contain = 0;
              if((typeof data['section-shop-the-look']) != 'undefined' && data['section-shop-the-look']){
                for(var i=0; i<related_product_handle_arr.length; i++){
                    if(data['section-shop-the-look'].indexOf(related_product_handle_arr[i]) !== -1){
                      product_handle_contain = 1;
                    }
                }
              }
              if(product_handle_contain == 1){
                related_product_new.before(data['section-shop-the-look']);
                console.log(related_product_handle);
                $('.shop_by_room .shop_room_img').each(function(){
                    var len_count = $(this).find('.new-product-sign').length;
                    var len_i = 0;
                    $(this).find('.new-product-sign').each(function(){
                      console.log($(this).attr('product_handle'));
                      if(related_product_handle.indexOf($(this).attr('product_handle')) === -1){
                          len_i++;
                      }
                    });
                    if(len_count == len_i){
                      $(this).remove();
                    }
                });
                if($('.new-product-sign').length > 0){
                  $('.section-shop-the-look .instagram_gallery_title').html('Get Inspired By Room Ideas');
                  $('.shop_by_room').addClass('shop_by_room_all');
                  $('.new-product-sign').each(function() {
                    var product_handle_str = $(this).attr('product_handle');
                    var product_info = getProductInfo(product_handle_str, $(this), getShopByRoomProductInfo);
                  });
                  //related_product_new.css('margin-top','10px')
                  shopRoomMethod ();
                  $('.shop_by_room').find('.idea-list-btn').removeClass('hide');
                  $('.image-list-slick-room-modal form.room-modal-cart').on('submit', function(event) {
                    event.preventDefault(); // prevent default form submission
                    $.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data: $(this).serialize(),
                      dataType: 'json',
                      success: function(line_item) {
                        //console.log(12, line_item);
                        if ((typeof ajaxCart) != 'undefined' && (typeof ajaxCart.itemAddedCallback) != 'undefined' && (typeof ajaxCart.itemAddedCallback) === 'function') {
                          if((typeof line_item.items) != 'undefined' && $.isArray(line_item.items)){
                            ajaxCart.itemAddedCallback(line_item.items[line_item.items.length-1], '.image-list-slick-room-modal form.room-modal-cart');
                          }else{
                            ajaxCart.itemAddedCallback(line_item, '.image-list-slick-room-modal form.room-modal-cart');
                          }
                        } else {
                          ShopifyAPI.onItemAdded(line_item, '.image-list-slick-room-modal form.room-modal-cart');
                        }
                      },
                      error: function(data) {
                        console.log(22, data);
                      }
                    });
                  });
                }
              }
            },
            error: function(jqXHR, textStatus, errorThrown) {
              console.error("Error fetching line-item-list content:", errorThrown);
            }
        });
    }
   judgemeProductUrlChange();
  
  if($('.judge_medals').length){
     const isHaveDom = $(".jdgm-widget, .jdgm-all-reviews-page").length
     console.log('isHaveDom2',isHaveDom)
     /*if($(".jdgm-widget, .jdgm-all-reviews-page").length <= 0){
        jdgmSettings.widget_load_with_code_splitting ?
            parseFloat(jdgmSettings.widget_version) >= 3 ? jdgm.loadCSS(jdgm.CDN_HOST + "widget_v3/base.css") :
            jdgm.loadCSS(jdgm.CDN_HOST + "widget/base.css") : jdgm.loadCSS(jdgm.CDN_HOST + "shopify_v2.css"),
            jdgm.loadJS(jdgm.CDN_HOST + "loader.js");
      }*/
      ajaxGetSections('judge_medals','.judge_medals',function(ele_obj, data){
        if((typeof data.judge_medals) != 'undefined' && data.judge_medals){
          $(ele_obj).html($(data.judge_medals).html());
          //if (isHaveDom <= 0) {
           setTimeout(function(){
              jdgm && jdgm.loadJS && jdgm.loadJS(jdgm.CDN_HOST + "loader.js");
           }, 1300)
          //};
          $('#shopify-section-footer .jdgm-medals').attr('data-link','https://www.sikaic.com/pages/reviews');
        }
      });
   }
});
function copyMethod (spu_no) {
    try {
         const newInput = document.createElement("input");
         newInput.value = spu_no;
         document.body.appendChild(newInput);
         newInput.select();
         document.execCommand("Copy");
         newInput.remove();
         showCustomModal();
     } catch (e) {
       console.log(e);
     }
}
function showCustomModal() {
    //var modal = document.getElementById("customModal");
    //modal.style.display = "block";
    $('.ant-message').css('display', 'block');
    $('.newsletter-subscribed-success-popup').hide();
    setTimeout(function () {
        hideCustomModal();
    }, 2000);
}
function hideCustomModal() {
    //var modal = document.getElementById("customModal");
    //modal.style.display = "none";
   $('.ant-message').css('display', 'none');
}
function getProductInfo(product_handle, ele_obj, callback) {
    if (product_handle) {
      try{
        jQuery.ajax({
            dataType: "json",
            url: "/products/" + $.trim(product_handle) + ".js",
            cache: false,
            success: function(data) {
                callback && callback(ele_obj, data);
            },
            error: function() {

            }
        });
      } catch (e) {
       console.log(e);
      }
    }
}
function getInstagramProductInfo(ele_obj, product_info){
    if(ele_obj && ele_obj.length && product_info && (typeof product_info.featured_image) != 'undefined' && product_info.featured_image){
        $(ele_obj).find('a').attr('href', product_info.url);
        $(ele_obj).find('img.img-responsive').attr('src',product_info.featured_image+'&width=200');
        if(product_info.compare_at_price == null){
            $(ele_obj).find('span.price').html(Shopify.formatMoney(product_info.price, window.money_format));
        }else{
            $(ele_obj).find('span.price').html(Shopify.formatMoney(product_info.price, window.money_format));
            $(ele_obj).find('s.price-old').html(Shopify.formatMoney(product_info.compare_at_price, window.money_format));
        }
    }
}
var slickDom = null;
function instagramGalleryMethod() { // 相册页面功能
    if($('.section-instagram-gallery').length <= 0) {
      return;
    }
    $(document).on('click', '.image-list-item', function() {
      $('.image-list-item-video').each(function(){
          $(this).attr('poster',$(this).attr('data-poster'));
         });
        let indexData = $(this).find('.img-box').attr('index');
        slickDom.slick('slickGoTo', Number(indexData)-1);
        const curDom = $('.image-list-slick-modal .image-list-item-video');
        for(let i = 0; i < curDom.length; i ++){
          curDom[i].addEventListener('pause', function() {
            $(curDom[i]).siblings('.video-icon').show();
          })
          curDom[i].addEventListener('play', function() {
            $(curDom[i]).siblings('.video-icon').hide();
            const curDom1 = $('.image-list-slick-modal .image-list-item-video');
            for(let i = 0; i < curDom1.length; i ++){
              const curClass =  $(curDom1[i]).parent().attr('class')
              if ($(curDom1[i]) && $(curDom1[i]).length > 0) {
               if (curClass.indexOf('slick-active') == 0){
                   $(curDom1[i])[0].pause()
               }
             }
            }
          })
          curDom[i].addEventListener('ended', function() {
            $(curDom[i]).siblings('.video-icon').show();
          })
        }
        setTimeout(function() {
          $('.image-list-slick-modal .video-icon').show();
        }, 800);
        $('body').addClass('cartover');
        $(".image-list-slick-modal").show();
    })
   $(document).on('click', '.slick-modal-mask-close', function() {
        $(".image-list-slick-modal").hide();
        $('body').removeClass('cartover');
        pauseVideo();
        
    })
    $(document).on('click', '.image-list-slick-modal .video-icon', function() {
      pauseVideo();
      const $domVideo = $(this).siblings('video');
      if ($domVideo && $domVideo.length > 0) {
        $domVideo[0].play();
        $(this).hide();
      }
    })
    $(document).on('click', '.section-instagram-gallery .next-slide', function(e) {
       pauseVideo();
       if (e && e.preventDefault){
           e.preventDefault();
       } else {
          window.event.returnValue = false;
       }
       if(e && e.stopPropagation){
          e.stopPropagation()
       }
       return false;
    })
    $(document).on('click', '.section-instagram-gallery .prev-slide', function(e) {
       pauseVideo();
       if (e && e.preventDefault){
           e.preventDefault();
       } else {
          window.event.returnValue = false;
       }
       if (e && e.stopPropagation){
         e.stopPropagation()
       }
       return false;
    })
    function pauseVideo() {
      const curDom = $('.image-list-slick-modal .image-list-item-video');
      for(let i = 0; i < curDom.length; i ++){
       if ($(curDom[i]) && $(curDom[i]).length > 0) {
         $(curDom[i])[0].pause()
       }
      }
    }
   slickDom =  $('.image-list-slick-modal .image-list-slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: isAppleMobile() ?  false : true, 
      infinite: true,
      vertical: false,
      verticalSwiping: false,
      centerMode: false,
      centerPadding: 0,
      prevArrow:'<span class="prev-slide"><i class="fa fa-angle-left"></i></span>',
      nextArrow:'<span class="next-slide"><i class="fa fa-angle-right"></i></span>',
      focusOnSelect: false,
      swipe: isAppleMobile() ?  false : true,
      //lazyLoad:'ondemand'
  })
  $('.js_section_instagram_gallery .image-list').slick({
      slidesToShow:  $(window).width() > 990 ? 3 : 2,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      vertical: false,
      verticalSwiping: false,
      centerMode: false,
      centerPadding: 0,
      prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow:'<button type="button" class="next-slide" aria-label="next"><i class="fa fa-angle-right"></i></button>',
      focusOnSelect: false,
      //lazyLoad:'ondemand',
  })
  slickDom.on("afterChange", function(e, slick, currentSlide){
     if (e && e.preventDefault){
         e.preventDefault();
     } else {
        window.event.returnValue = false;
     }
     if (e && e.stopPropagation){
       e.stopPropagation()
     }
  })
  const height1 = $('.image-list-item').width();
  $(".image-list-item .img-box img").css('height', height1+'px');
  $(".image-list").css('opacity', 1);
}
// 是否为 iPhone
function isAppleMobile() {
    return (navigator.platform.indexOf('iPhone') != -1);
}
/*remove #judgeme_product_reviews from product url*/
function judgemeProductUrlChange(){
  if($('.jdgm-rev__prod-info-wrapper .jdgm-rev__prod-link').length > 0){
   $('.jdgm-rev__prod-info-wrapper .jdgm-rev__prod-link').each(function(){
    $(this).attr('href',$(this).attr('href').replace('#judgeme_product_reviews',''));
   });
  }
}
function getShopByRoomProductInfo(ele_obj, product_info){
        if(ele_obj && ele_obj.length && product_info && (typeof product_info.featured_image) != 'undefined' && product_info.featured_image){
            var variant_sku = $(ele_obj).attr('variant_sku');
            $(ele_obj).attr('tags',product_info.tags );
            if(product_info.variants.length <= 0 || variant_sku == ''){
                $(ele_obj).attr('product_url',product_info.url);
                $(ele_obj).find('.room-product-info-title').html(product_info.title);
                $(ele_obj).find('img.shop_room_product_img').attr('src',product_info.featured_image+'&width=400');
                if(product_info.compare_at_price == null){
                    $(ele_obj).attr('product_title',product_info.title).attr('product_img',product_info.featured_image+'&width=400').attr('product_old_price','').attr('product_price',product_info.price).attr('product_variant_id',product_info.id).attr('product_id',product_info.id);
                    $(ele_obj).find('span.product-info-red-price').html(Shopify.formatMoney(product_info.price, window.money_format));
                    $(ele_obj).find('span.product-info-tag-price').html('');
                    $(ele_obj).find('span.enj-product-price-save').html('');
                    $(ele_obj).find('.digger_price_input').val(product_info.id).attr('price', product_info.price).attr('compare_at_price', 0).attr('save_price', 0).attr('save_off', '').attr('id', 'digger_price_'+product_info.id);
                }else{
                    $(ele_obj).attr('product_title',product_info.title).attr('product_img',product_info.featured_image+'&width=400').attr('product_old_price',product_info.compare_at_price).attr('product_price',product_info.price).attr('product_variant_id',product_info.id).attr('product_id',product_info.id);
                    $(ele_obj).find('span.product-info-red-price').html(Shopify.formatMoney(product_info.price, window.money_format));
                    $(ele_obj).find('span.product-info-tag-price').html(Shopify.formatMoney(product_info.compare_at_price, window.money_format));
                    var save_price_off = parseInt((product_info.compare_at_price-product_info.price) / product_info.compare_at_price * 100);
                    var save_price_off_format = Shopify.formatMoney((product_info.compare_at_price-product_info.price), window.money_format);
                    save_price_off_format = "Save " + save_price_off_format + "("+save_price_off+"%)";
                    $(ele_obj).find('span.enj-product-price-save').html(save_price_off_format);
                    $(ele_obj).find('.digger_price_input').val(product_info.id).attr('price', product_info.price).attr('compare_at_price', product_info.compare_at_price).attr('save_price', product_info.compare_at_price - product_info.price).attr('save_off', save_price_off_format).attr('id', 'digger_price_'+product_info.id);
                }
            }else{
                for(variants_i=0; variants_i<product_info.variants.length; variants_i++){
                    if(product_info.variants[variants_i].sku == variant_sku){
                        $(ele_obj).attr('product_url',product_info.url+'?variant='+product_info.variants[variants_i].id);
                        $(ele_obj).find('.room-product-info-title').html(product_info.variants[variants_i].name);
                        if(product_info.variants[variants_i].featured_image == null){
                            $(ele_obj).attr('product_title',product_info.variants[variants_i].name).attr('product_img',product_info.featured_image+'&width=400').attr('product_variant_id',product_info.variants[variants_i].id).attr('product_id',product_info.id);
                            $(ele_obj).find('img.shop_room_product_img').attr('src',product_info.featured_image+'&width=400');
                        }else{
                            $(ele_obj).attr('product_title',product_info.variants[variants_i].name).attr('product_img',product_info.variants[variants_i].featured_image.src+'&width=400').attr('product_variant_id',product_info.variants[variants_i].id).attr('product_id',product_info.id);
                            $(ele_obj).find('img.shop_room_product_img').attr('src',product_info.variants[variants_i].featured_image.src+'&width=400');
                        }

                        if(product_info.variants[variants_i].compare_at_price == null){
                            $(ele_obj).attr('product_old_price','').attr('product_price',product_info.price);
                            $(ele_obj).find('span.product-info-red-price').html(Shopify.formatMoney(product_info.variants[variants_i].price, window.money_format));
                            $(ele_obj).find('span.product-info-tag-price').html('');
                            $(ele_obj).find('span.enj-product-price-save').html('');
                            $(ele_obj).find('.digger_price_input').val(product_info.variants[variants_i].id).attr('price', product_info.variants[variants_i].price).attr('compare_at_price', 0).attr('save_price', 0).attr('save_off', '').attr('id', 'digger_price_'+product_info.variants[variants_i].id);
                        }else{
                            $(ele_obj).attr('product_old_price',product_info.variants[variants_i].compare_at_price).attr('product_price',product_info.variants[variants_i].price);
                            $(ele_obj).find('span.product-info-red-price').html(Shopify.formatMoney(product_info.variants[variants_i].price, window.money_format));
                            $(ele_obj).find('span.product-info-tag-price').html(Shopify.formatMoney(product_info.variants[variants_i].compare_at_price, window.money_format));
                            var save_price_off = parseInt((product_info.variants[variants_i].compare_at_price-product_info.variants[variants_i].price) / product_info.variants[variants_i].compare_at_price * 100);
                            var save_price_off_format = Shopify.formatMoney((product_info.variants[variants_i].compare_at_price-product_info.variants[variants_i].price), window.money_format);
                            save_price_off_format = "Save " + save_price_off_format + "("+save_price_off+"%)";
                            $(ele_obj).find('span.enj-product-price-save').html(save_price_off_format);
                            $(ele_obj).find('.digger_price_input').val(product_info.variants[variants_i].id).attr('price', product_info.variants[variants_i].price).attr('compare_at_price', product_info.variants[variants_i].compare_at_price).attr('save_price', product_info.variants[variants_i].compare_at_price - product_info.variants[variants_i].price).attr('save_off', save_price_off_format).attr('id', 'digger_price_'+product_info.id);
                        }
                    }
                }
            }
        }
}
function getPreviewBadgeByJudgeApi(product_handle, ele_obj) {
    if (product_handle && (typeof judge_api_authorize_params) != 'undefined' && judge_api_authorize_params) {
     try {
       jQuery.ajax({
           dataType: "json",
           url: 'https://judge.me/api/v1/widgets/preview_badge?'+judge_api_authorize_params+ '&handle=' + $.trim(product_handle),
           cache: false,
           success: function(data) {
               if(data && (typeof data.badge) != 'undefined' && data.badge && data.badge.indexOf('No reviews') === -1){
                  ele_obj.empty().html(data.badge);
               }else{
                  ele_obj.html('');
               }
           },
           error: function() {
  
           }
      });
    } catch (e) {
       console.log(e);
    }
  }
}
var myCarousel = null;
function shopRoomMethod () {
  if($('.section-shop-the-look').length <= 0) {
    return;
  }
  $(document).on('mouseover', '.shop_room_home .shop_room_img', function() {
      $(this).find('.tag-circle').css('display', 'flex');
  })
  $(document).on('mouseleave', '.shop_room_home .shop_room_img', function() {
      //$(this).find('.tag-circle').hide();
      const haveClass = $(this).parents('.shop_by_room').attr('class')
      if (haveClass.indexOf('shop_by_room_details') > -1) {
        if ($(this).index() === 0) {
            return
        }
        $(this).find('.tag-circle').hide();
        $(this).find('.product-sign-line').hide();
        $(this).find('.product-sign-info').hide();
      }
  })
  
  $(document).on('mouseover', '.shop_room_home .shop_room_img .tag-circle', function() {
      const haveClass = $(this).parents('.shop_by_room').attr('class')
      if (haveClass.indexOf('shop_by_room_details') > -1) {
        $(this).siblings('.product-sign-line').show();
        $(this).addClass('light-tag-circle').siblings('.product-sign-info').css('display', 'flex');
      } else {
        $(this).addClass('light-tag-circle');
      }
  })
  
  $(document).on('mouseleave', '.shop_room_home .shop_room_img .new-product-sign', function() {
      const haveClass = $(this).parents('.shop_by_room').attr('class')
      if (haveClass.indexOf('shop_by_room_details') > -1) {
        $(this).find('.product-sign-line').hide();
        $(this).find('.product-sign-info').hide();
      }
      $(this).find('.tag-circle').removeClass('light-tag-circle');
  })
  
  $(document).on('click', '.shop_room_home .shop_room_img .tag-circle', function() {
      openDetailsContentTow($(this));
      $('.image-list-slick-room-modal .room-good-list-btn').remove();
      $('.image-list-slick-room-modal .room-modal-bottom-btns .roomGoodButton1').removeClass('viewCheckOut');
  })
  
  $(document).on('click', '.room-image-list-content .room-good-list .room-good-checkbox', function() {
      const curClass = $(this).attr('class');
      if (curClass.indexOf('checkbox-checked') > -1) {
          $(this).removeClass('checkbox-checked');
      } else {
          $(this).addClass('checkbox-checked');
      }
      const tagPriceArr = []
      const priceArr = []
      const productSign = $('.room-image-list-content .room-good-list .checkbox-checked').find('input');
      let buttonStr = ''
      for(let i =0; i<productSign.length; i++) {
        const productPrice =  $(productSign[i]).attr('value');
        const productOldPrice =  $(productSign[i]).attr('product_old_price');
        const product_variant_id =  $(productSign[i]).attr('product_variant_id');
        const num =  $(productSign[i]).attr('indexnum');
        if(productOldPrice == '' || productOldPrice == 0){
          tagPriceArr.push(productPrice);
        }else{
          tagPriceArr.push(productOldPrice);
        }
        priceArr.push(productPrice)
        buttonStr +='<input type="hidden" name="items['+ num +'][quantity]" value="1">'+'<input type="hidden" name="items['+ num +'][id]" value="'+product_variant_id+'">'
      }
      const discount = $('.image-list-slick-room-modal #discount_code_off').length > 0 ? $('.image-list-slick-room-modal #discount_code_off').attr('data') : $(".section-shop-the-look .coupon-info #discount_code_off").attr('data');
      const discountRate = discount ? 1 - (Number(discount)/100) : 1;//折扣率
      const couponInfo = $(".section-shop-the-look .coupon-info").prop('outerHTML');
      const couponInfo1 = couponInfo ? couponInfo : '';
      const priceTotal = sumMethod(priceArr);
      const tagPriceTotal = sumMethod(tagPriceArr);
      const tagPriceTotalNum = tagPriceTotal == 0 ? 1 : Number(tagPriceTotal);
      const savePrice = Number(tagPriceTotal) - Number(priceTotal);
      const priceRate = (Number(tagPriceTotal) - Number(priceTotal))/tagPriceTotalNum;
      const priceRatetoFixed = priceRate.toFixed(2)*100 + '%';
      let savePriceStr = 'Save '+Shopify.formatMoney(savePrice, window.money_format)+' ('+priceRatetoFixed+')';
      let itemStr = '( ' +productSign.length+ ' Items ) Subtotal:'
      const $listTotal = $('.room-image-list-content .room-good-list-total');
      let discountPriceTotalFormat = '';
      if (couponInfo1) { // 有优惠券
         const discountPriceTotal = sumDiscountMethod(priceArr,discountRate);
         discountPriceTotalFormat = Shopify.formatMoney(discountPriceTotal, window.money_format);//折扣后价格转美元
         const discountSavePrice = Number(tagPriceTotal) - Number(discountPriceTotal); //折扣后节省钱
         const discountPriceRate = (Number(tagPriceTotal) - Number(discountPriceTotal))/tagPriceTotalNum;
         const discountPriceRatetoFixed = (discountPriceRate*100).toFixed(0) + '%';
         savePriceStr = 'Save '+Shopify.formatMoney(discountSavePrice, window.money_format)+' ('+discountPriceRatetoFixed+')';
      }
      $listTotal.show();
      $('.room-image-list-content .room-good-list-btn').show();
      if (productSign.length < 2) { //只选中了一个
        itemStr = '( ' +productSign.length+ ' Item ) Subtotal:'
        if (productSign.length == 1) {
          $listTotal.find('.price-canpup-info').hide();
          $('.image-list-slick-room-modal .room-good-list-btn .roomGoodButton').text('Buy Now');
          $('.image-list-slick-room-modal .product-info-price .product-info-red-price').removeClass('discountPriceStyle');
        } else {
          $listTotal.hide();
          $('.room-image-list-content .room-good-list-btn').hide();
        } 
      } else {
         $listTotal.find('.price-canpup-info').show();
         $('.image-list-slick-room-modal .room-good-list-btn .roomGoodButton').text('Buy Together');
         $('.image-list-slick-room-modal .product-info-price .product-info-red-price').addClass('discountPriceStyle');
      }
      $listTotal.find('.product-info-red-price').text(Shopify.formatMoney(priceTotal, window.money_format));
      $listTotal.find('.product-info-tag-price').text(Shopify.formatMoney(tagPriceTotal, window.money_format));
      discountPriceTotalFormat && $listTotal.find('.price-canpup-info .product-info-red-price').text(discountPriceTotalFormat);
      $listTotal.find('.enj-product-price-save').text(savePriceStr);
      $listTotal.find('.room-good-list-total-item').text(itemStr);
      $('.image-list-slick-room-modal .room-modal-cart-div').empty().append(buttonStr);
      $('.image-list-slick-room-modal .room-modal-bottom-btns').css('opacity', 0);
  })

  $(document).on('click', '.shop_room_home .idea-list-btn', function() {
      const productSign = $(this).siblings('.idea-image').find('.new-product-sign');
      const tagPriceArr = []
      const priceArr = []
      let curDom = ''
      let buttonStr = ''
      for(let i =0; i<productSign.length; i++) {
        const productPrice =  $(productSign[i]).attr('product_price');
        const productOldPrice =  $(productSign[i]).attr('product_old_price');
        const product_img =  $(productSign[i]).attr('product_img');
        const product_variant_id = $(productSign[i]).attr('product_variant_id'); 
        const product_url = $(productSign[i]).attr('product_url');
        if(productOldPrice == '' || productOldPrice == 0){
          tagPriceArr.push(productPrice);
        }else{
          tagPriceArr.push(productOldPrice);
        }
        priceArr.push(productPrice);
        curDom+='<div href="javascript:void(0)" class="home-card-list">'
                  +'<div class="home-card-top">'
                  + '<img src="'+product_img+'">'
                   + '<span class="room-good-checkbox checkbox-checked">'
                      +   '<input type="checkbox" value="'+productPrice+'" product_old_price="'+productOldPrice+'"  product_variant_id="'+product_variant_id+'" indexnum="'+i+'"  style="display: none;">'
                       +   '<span class="checkbox-inner"></span>'
                      +'</span>'
                  +'</div>'
                  +'<div class="product-info-price">'
                  + $(productSign[i]).find('.product-info-price').last().html()
                  +'</div>'
                  +'<a  href="'+product_url+'" target="_blank" class="room-modal-left-btn">'
                  +  '<span>Full Details </span>' 
                  +'</a> '
              +'</div>'

         buttonStr +='<input type="hidden" name="items['+ i +'][quantity]" value="1">'+'<input type="hidden" name="items['+ i +'][id]" value="'+product_variant_id+'">'
      }
      const discount = $('.image-list-slick-room-modal #discount_code_off').length > 0 ? $('.image-list-slick-room-modal #discount_code_off').attr('data') : $(".section-shop-the-look .coupon-info #discount_code_off").attr('data');
      const discountRate = discount ? 1 - (Number(discount)/100) : 1;//折扣率
      const couponInfo = $(".section-shop-the-look .coupon-info").prop('outerHTML');
      const couponInfo1 = couponInfo ? couponInfo : '';
      const priceTotal = sumMethod(priceArr);
      const tagPriceTotal = sumMethod(tagPriceArr);
      const tagPriceTotalNum = tagPriceTotal == 0 ? 1 : Number(tagPriceTotal) 
      const savePrice = Number(tagPriceTotal) - Number(priceTotal)
      const priceRate = (Number(tagPriceTotal) - Number(priceTotal))/tagPriceTotalNum;
      const priceRatetoFixed = (priceRate*100).toFixed(0) + '%';
      const priceTotalFormat = Shopify.formatMoney(priceTotal, window.money_format);
      const tagPriceTotalFormat = Shopify.formatMoney(tagPriceTotal, window.money_format);
      let savePriceStr = 'Save '+Shopify.formatMoney(savePrice, window.money_format)+' ('+priceRatetoFixed+')';
      let discountHtml = ''
      let discountPriceClass = ''
      if (couponInfo1) { // 有优惠券
         const discountPriceTotal = sumDiscountMethod(priceArr,discountRate);
         const discountPriceTotalFormat = Shopify.formatMoney(discountPriceTotal, window.money_format);//折扣后价格转美元
         const discountSavePrice = Number(tagPriceTotal) - Number(discountPriceTotal); //折扣后节省钱
         const discountPriceRate = (Number(tagPriceTotal) - Number(discountPriceTotal))/tagPriceTotalNum;
         const discountPriceRatetoFixed = (discountPriceRate*100).toFixed(0) + '%';
         savePriceStr = 'Save '+Shopify.formatMoney(discountSavePrice, window.money_format)+' ('+discountPriceRatetoFixed+')';
         discountPriceClass = 'discountPriceStyle' // 有优惠券时加上class
         discountHtml = '<div class="price-canpup-info">'
                +'<div class="price-canpup-info-top">'
            	  +'<span> EXTRA <i>10</i>% OFF</span>'
            	+'</div>'
            	+'<div class="price-canpup-info-bottom" style="margin-top: 8px;">'
            	+	'<span class="product-info-red-price" style="font-size: 28px;">'+discountPriceTotalFormat+'</span>'
            	+'</div>'
              +'</div>';
      }
      $('.image-list-slick-room-modal .room-good-list-btn').remove();
      if (productSign.length > 0) {
          const donString = '<div class="room-good-list">'+curDom+'</div>'+couponInfo1
              +'<div style="display: flex;justify-content: center;">'
              +'<div class="room-good-list-total">'
              +'<div class="room-good-list-total-item"> ( '+ productSign.length +' Items ) Subtotal:</div>'
              +'<div class="product-info-price">'
                  +'<span class="product-info-red-price '+discountPriceClass+'"> '+priceTotalFormat+'</span>'
                  +'<span class="product-info-tag-price"> '+tagPriceTotalFormat+ '</span>'
              +'</div>'
              +discountHtml
              +'<span class="enj-product-price-save">'+savePriceStr+'</span>'
              +'</div>'
              +'</div>'
              //+'<div class="room-good-list-btn"><button class="roomGoodButton">Buy Together</button></div>'

            const donString1 = '<div class="room-good-list-btn">'
              +'<span class="roomGoodButton">Buy Together</span>'
              +'<span class="room-modal-cart" style="margin-top: 10px;"><button class="roomGoodButton1">Add To Cart</button></span>'
              +'</div>'
          openDetailsContent(donString);
          $('.image-list-slick-room-modal .room-modal-bottom-btns').before(donString1);
      }
      $(".image-list-slick-room-modal .image-list-room-modal-title").text('Shop This Idea');
      $(".image-list-slick-room-modal").addClass('room-modal-open');
      $('.image-list-slick-room-modal .room-modal-cart-div').empty().append(buttonStr);
      $('.image-list-slick-room-modal .room-modal-bottom-btns').css('opacity', 0);
      if (productSign.length == 1) {
          $(".image-list-slick-room-modal").find('.room-good-list').css('justify-content', 'center');
      }
      const curWidth = $(".image-list-slick-room-modal .home-card-top").width();
      $(".room-image-list-content .room-good-list img").css('height', curWidth+'px');
      $(".image-list-slick-room-modal .coupon-info").removeClass('hide');
      $('body').addClass('cartover');
      $('.image-list-slick-room-modal .room-modal-bottom-btns .roomGoodButton1').removeClass('viewCheckOut');
  })
  
  $(document).on('click', '.shop_by_room .shop_room_home .product-sign-info', function() {
      openDetailsContentTow($(this))
      $('.image-list-slick-room-modal .room-good-list-btn').remove();
      $('.image-list-slick-room-modal .room-modal-bottom-btns .roomGoodButton1').removeClass('viewCheckOut');
  })
  
  $(document).on('click', '.image-list-slick-room-modal .enj-add-to-cart-btn', function() {
      $(".image-list-slick-room-modal").removeClass('room-modal-open').removeClass('room-modal-mask-open');
  })
  
  $(document).on('click', '.shop_by_room_home .filter_button .filter_button_item', function() {
      $(this).addClass('filter_button_item_active').siblings().removeClass('filter_button_item_active');
      var filterClass = $(this).attr("filter-class");
      myCarousel.slick('slickUnfilter');
      if(typeof($(this).attr("filter-class"))=="undefined"){
        myCarousel.slick('slickGoTo', 0, true);
      }else{
        myCarousel.slick('slickFilter', '.'+filterClass);
      }
  })
  
  $(document).on('click', '.image-list-slick-room-modal .room-image-list-content .roomGoodButton', function() {
    $('.image-list-slick-room-modal .enj-add-to-cart-btn').click();
  })
  
  $(document).on('click', '.image-list-slick-room-modal .slick-room-modal-mask-close', function() {
      $(".image-list-slick-room-modal").removeClass('room-modal-open').removeClass('room-modal-mask-open')//.hide();
      $(".image-list-slick-room-modal .image-list-room-modal-title").text('Product Details');
      $('body').removeClass('cartover');
  })

  //Room Ideas集合页面过滤
  $(document).on('mouseover', '.filter_button .filter_button_item-div', function() {
      $(this).find('.filter-content-ul').show()
      $(this).siblings().find('.filter-content-ul').hide();
  })
  
  $(document).on('mouseleave', '.filter_button .filter_button_item-div', function() {
      $(this).find('.filter-content-ul').hide()
      $(this).siblings().find('.filter-content-ul').hide();
  })
  
  $(document).on('click', '.filter-result .filter-result-item', function() {
      const titleName = $(this).find('.filter-result-item-name').attr('titlename');
      $(this).remove();
      const resultIitemDom = $('.filter_button .filter-content-item .filter-content-item-name');
      const resultIitemDomMobile = $('.mobile-filter-room-modal .filter-room-modal-item .filter-content-item-name');
      filterContentCommon(resultIitemDom, titleName);
      filterContentCommon(resultIitemDomMobile, titleName);
      hideResultContent();
  })
  
  $(document).on('click', '.filter-result .clear-all', function() {
      $('.filter-result .filter-result-item').remove();
      $('.filter-result').hide();
      $('.filter_button .filter-content-item .filter-content-checkbox').removeClass('filter-checkbox-checked');
      $('.mobile-filter-room-modal .filter-room-modal-item .filter-content-checkbox').removeClass('filter-checkbox-checked');
      $('.filter_button .filter_button_item').removeClass('filter_button_item_active');
      getAllFilterResultClass();
  })
  
  $(document).on('click', '.filter_button .filter-button-content .filter-content-item', function() { // 复选框逻辑
      const curClass = $(this).find('.filter-content-checkbox').attr('class');
      const titleName = $(this).find('.filter-content-item-name').text();
      const btnName = $(this).parent().siblings().find('i').text();
      const filterClass =  $(this).find('.filter-content-item-name').attr('filter-class')
      const strName = btnName+': '+titleName;
      appendContentCommon($(this), filterClass, strName);
      buttonStyle($(this).parent());
      //hideResultContent();
  })
  // 移动端菜单
  $(document).on('click', '.mobile-room-image-list-content .filter_button_item-div .filter_button_item', function() { // 菜单收缩
      const isHiden = $(this).siblings().is(":hidden")
      if (isHiden) {
          $(this).siblings().show();
          $(this).find('.filter-icon-bottom').addClass('filter-icon-bottom-up');
      } else {
          $(this).siblings().hide();
          $(this).find('.filter-icon-bottom').removeClass('filter-icon-bottom-up');
      }
  })
  
  $(document).on('click', '.mobile-room-image-list-content .filter_button_item-div .mobile-filter-content-item', function() {
    const curClass = $(this).find('.filter-content-checkbox').attr('class');
    const titleName = $(this).find('.filter-content-item-name').text();
    const btnName = $(this).parent().siblings().find('span').text();
    const strName = btnName+': '+titleName;
    const filterClass =  $(this).find('.filter-content-item-name').attr('filter-class')
    const resultIitemDom = $('.filter_button .filter-content-item .filter-content-item-name')
    for(let i=0 ; i <resultIitemDom.length; i++){
        const curTitleName = $(resultIitemDom[i]).text();
        const checkedDom = $(resultIitemDom[i]).parents('.filter-content-ul').find('.filter-checkbox-checked');
        if (curTitleName == titleName) {
            if (curClass.indexOf('filter-checkbox-checked') > -1) { 
                $(resultIitemDom[i]).siblings().removeClass('filter-checkbox-checked');
            } else {
                $(resultIitemDom[i]).siblings().addClass('filter-checkbox-checked');
            }
        }
        buttonStyle($(resultIitemDom[i]).parents('.filter-content-ul'));
    }
    appendContentCommon($(this), filterClass, strName)
  })
  
  $(document).on('click', '.mobile-filter-room-modal .mobile-filter-room-modal-mask-close', function() {
      $(".mobile-filter-room-modal").removeClass('room-modal-open').removeClass('room-modal-mask-open');
      $('.mobile-filter-room-modal .mobile-room-image-list-content .filter-content-ul').hide()
      $('body').removeClass('cartover');
  })
  
  $(document).on('click', '.mobile-filter-room-modal .filter-room-modal-footer-btn', function() {
      $(".mobile-filter-room-modal").removeClass('room-modal-open').removeClass('room-modal-mask-open');
      $('.mobile-filter-room-modal .mobile-room-image-list-content .filter-content-ul').hide();
      $('body').removeClass('cartover');
  })

  $(document).on('touchend', '.shop_by_room_details .filter_button .filter_button_item', function() {
      //$(this).addClass('filter_button_item_active').siblings().removeClass('filter_button_item_active');
      const curClass = $('.mobile-filter-room-modal').attr('class')
      console.log('curClass34',curClass)
      if ($(window).width() < 990 && curClass.indexOf('room-modal-open') == -1) {
          $('.mobile-filter-room-modal').addClass('room-modal-open');
          const textName = $(this).find('i').text()
          const resultIitemDom = $('.mobile-filter-room-modal .filter_button_item').find('span')
          for(let i=0 ; i <resultIitemDom.length; i++){
              const curTitleName = $(resultIitemDom[i]).text();
              if (curTitleName == textName) {
                  $(resultIitemDom[i]).parent().siblings().show();
              } 
          }
      }
  })
  
  
  myCarousel = $('.shop_by_room_home .shop_room_home').slick({
    slidesToShow: $(window).width() > 990 ? 2 : 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: false,
    centerPadding: 0,
    prevArrow:'<button type="button" class="prev-slide" aria-label="Prev"><svg fill="none" width="25" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="Next"><svg fill="none" width="25" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
    focusOnSelect: false,
    lazyLoad:'ondemand'
  })
}

function openDetailsContentTow($dom) {
  let curDom = $dom.siblings('.product-sign-details-box').html();
  const content_infosale = $("#content_infosale_html").html();
  const product_handle = $dom.parent('.new-product-sign').attr('product_handle');
  const product_url = $dom.parent('.new-product-sign').attr('product_url');
  const product_variant_id = $dom.parent('.new-product-sign').attr('product_variant_id'); 
  let buttonStr ='<input type="hidden" name="items[0][quantity]" value="1">'+'<input type="hidden" name="items[0][id]" value="'+product_variant_id+'">'
  curDom += '<div class="room-modal-content-infosale list_ul_engo_full">'+content_infosale+'</div>'
      /*+'<div class="room-modal-bottom-btns">'
      +'<a  href="'+product_url+'" target="_blank" class="room-modal-left-btn">'
      +  '<span>Full Details </span>' 
      +'</a> '
      +'<div class="room-modal-add-cart-warp">'
      + '<button type="button" class="room-modal-cart-button">'
      +  '<span>Add To Cart</span>'
      + '</button>'
      +'</div>'
      +'</div>'*/
  openDetailsContent(curDom);
  const pre_sale_day_tmp = $dom.parent('.new-product-sign').attr('tags');
  const pre_sale_index = pre_sale_day_tmp.indexOf('PRE-SALE#');
  const discountcode_index = pre_sale_day_tmp.indexOf('DiscountCode');
  if(discountcode_index !== -1){
    var discountcode_str_tmp = pre_sale_day_tmp.substring(discountcode_index+12);
    const discountcode_index2 = discountcode_str_tmp.indexOf(',');
    if(discountcode_index2 !== -1){
      discountcode_str_tmp = discountcode_str_tmp.substring(0, discountcode_index2);
    }
    discountcode_str_arr = discountcode_str_tmp.split('---');
    $('.room-modal-content-infosale .free-sale-info, .room-modal-content-infosale .free-pre-sale-info').hide();
    if(discountcode_str_arr.length == 4){
      $('.room-modal-content-infosale .free-sale-info-day').html(discountcode_str_arr[3]).show();
      $('.room-modal-content-infosale .free-sale-info-code-off').html(discountcode_str_arr[2]);
      $('.room-modal-content-infosale .free-sale-info-code-name').html(discountcode_str_arr[1]);
      $('.room-modal-content-infosale .coupon-copy-btn').attr('data',discountcode_str_arr[1]);
      if(discountcode_str_tmp.indexOf('PRE-SALE') === -1){
        $('.room-modal-content-infosale .free-sale-info').show(); 
      }
    }
  }else if(pre_sale_index !== -1){
    var goods_pre_sale_day_tmp = pre_sale_day_tmp.substring(pre_sale_index+9);
    const pre_sale_index2 = goods_pre_sale_day_tmp.indexOf(',');
    if(pre_sale_index2 !== -1){
      goods_pre_sale_day_tmp = pre_sale_day_tmp.substring(0, pre_sale_index2);
    }
    $('.room-modal-content-infosale .pre-sale-label, .free-pre-sale-info').show();
    $('.room-modal-content-infosale .free-sale-info').hide();
    $('.room-modal-content-infosale .free-pre-sale-info label').html(goods_pre_sale_day_tmp);
  }else{
    $('.room-modal-content-infosale .pre-sale-label, .free-pre-sale-info').hide();
    $('.room-modal-content-infosale .free-sale-info').show();
  }
  $(".image-list-slick-room-modal").addClass('room-modal-open');
  $('.image-list-slick-room-modal .room-modal-bottom-btns .room-modal-left-btn').attr('href', product_url );
  $('.image-list-slick-room-modal .room-modal-cart-div').empty().append(buttonStr);
  $('.image-list-slick-room-modal .room-modal-bottom-btns').css('opacity', 1);
  getPreviewBadgeByJudgeApi(product_handle, $('.image-list-slick-room-modal .room-modal-preview-badge'));
  const curWidth = $('.image-list-slick-room-modal .room-image-list-content').width();
  $('.image-list-slick-room-modal .room-image-list-content>img').css('height', curWidth+'px');
  $('body').addClass('cartover');
}

function openDetailsContent(dom) {
  $('.room-image-list-content').empty().append(dom);
}

function sumMethod(arr) { // 求和
  let total = 0;
  arr.forEach(v => {
      total += v ? Number(v) : 0;
  })
  return arr.length > 0 ? total : 0
}

function sumDiscountMethod(arr, rate) { // 求和
  let total = 0;
  arr.forEach(v => {
      total += v ? Math.ceil(Number(v)*rate) : 0;
  })
  return total
}

function buttonStyle($dom) {
    const checkDom = $dom.find('.filter-checkbox-checked');
    if (checkDom.length > 0) {
        $dom.siblings().addClass('filter_button_item_active');
    } else {
        $dom.siblings().removeClass('filter_button_item_active');
    }
}

function hideResultContent(dom) {
    const $dom = $('.filter-result .filter-result-item');
    if ($dom.length == 0) {
        $('.filter-result').hide();
    } else {
        $('.filter-result').show();
    }
   getAllFilterResultClass();
}

function addFilterContent(dom) {
    if ($(window).width() > 990) {
      $('.filter-result .clear-all').before(dom);
    } else {
      $('.filter-result .clear-all').after(dom);
    }
}

function filterContentCommon(resultIitemDom, titleName) {
    for(let i=0 ; i <resultIitemDom.length; i++){
        const curTitleName = $(resultIitemDom[i]).attr('filter-class');
        const checkedDom = $(resultIitemDom[i]).parents('.filter-content-ul').find('.filter-checkbox-checked');
        if (curTitleName == titleName) {
            $(resultIitemDom[i]).siblings().removeClass('filter-checkbox-checked');
        }
        buttonStyle($(resultIitemDom[i]).parents('.filter-content-ul'));
    }
}
function appendContentCommon($dom, titleName, strName) {
    const curClass = $dom.find('.filter-content-checkbox').attr('class');
    if (curClass.indexOf('filter-checkbox-checked') > -1) { // 取消选中
        $dom.find('.filter-content-checkbox').removeClass('filter-checkbox-checked');
        const resultIitemDom = $('.filter-result .filter-result-item .filter-result-item-name');
        for(let i=0 ; i <resultIitemDom.length; i ++){
            const curTitleName = $(resultIitemDom[i]).attr('titlename');
            if (curTitleName == titleName) {
                $(resultIitemDom[i]).parent().remove();
            }
        }
    } else {
        $dom.find('.filter-content-checkbox').addClass('filter-checkbox-checked');
        let domStr = '<div class="filter-result-item">'
                    +'<span class="filter-result-item-name" titlename="'+titleName+'">'+strName+'</span>'
                    +'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="14" height="14" fill="#212529" viewBox="0 0 298.667 298.667" style="enable-background:new 0 0 298.667 298.667;" xml:space="preserve">'
                        +'<g>'
                        +'<g>'
                        + '<polygon points="298.667,30.187 268.48,0 149.333,119.147 30.187,0 0,30.187 119.147,149.333 0,268.48 30.187,298.667     149.333,179.52 268.48,298.667 298.667,268.48 179.52,149.333"></polygon>'
                        +'</g>'
                        +'</g>'
                        +'</svg>'
                    +'</div>'
        addFilterContent(domStr)
    }
    hideResultContent();
}
function getAllFilterResultClass(){
  const filterClassSelectedRoom = [];
  const filterClassSelectedStyle = [];
  const filterClassSelectedColor = [];
  const filterClassSelectedMaterial = [];
  const resultIitemDom = $('.filter-result .filter-result-item .filter-result-item-name');
  for(let i=0 ; i <resultIitemDom.length; i++){
      const curTitleName = $(resultIitemDom[i]).attr('titlename');
      if(curTitleName.indexOf('_room_') !== -1){
        filterClassSelectedRoom.push(curTitleName);
      }else if(curTitleName.indexOf('_style_') !== -1){
        filterClassSelectedStyle.push(curTitleName);
      }else if(curTitleName.indexOf('_color_') !== -1){
        filterClassSelectedColor.push(curTitleName);
      }else if(curTitleName.indexOf('_material_') !== -1){
        filterClassSelectedMaterial.push(curTitleName);
      }
  }
  addFilterShopRoomImg(filterClassSelectedRoom,filterClassSelectedStyle,filterClassSelectedColor,filterClassSelectedMaterial);
}
function checkDomHasClass($dom,arr)
{
  if(arr.length <= 0){
    return true;
  }
  for(var i=0; i<arr.length; i++){
    if($dom.hasClass(arr[i])){
      return true;
    }
  }
  return false;
}
function addFilterShopRoomImg(roomArr,styleArr,colorArr,materialArr){
  if(roomArr.length <= 0 && styleArr.length <= 0 && colorArr.length <= 0 && materialArr.length <= 0) {
    $('.shop_by_room .shop_room_img').show();
  }else{
    $('.shop_by_room .shop_room_img').hide();
    $('.shop_by_room .shop_room_img').each(function(){
      if(checkDomHasClass($(this),roomArr) && checkDomHasClass($(this),styleArr) && checkDomHasClass($(this),colorArr) && checkDomHasClass($(this),materialArr)){
          $(this).show();
      }
    });
  }
}
function ajaxAddCartByForm(form_selector){
    $(form_selector).on('submit', function(event) {
      event.preventDefault(); // prevent default form submission
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).serialize(),
        dataType: 'json',
        success: function(line_item) {
          //console.log(12, line_item);
          if ((typeof ajaxCart) != 'undefined' && (typeof ajaxCart.itemAddedCallback) != 'undefined' && (typeof ajaxCart.itemAddedCallback) === 'function') {
            if((typeof line_item.items) != 'undefined' && $.isArray(line_item.items)){
              ajaxCart.itemAddedCallback(line_item.items[line_item.items.length-1], $(this));
            }else{
              ajaxCart.itemAddedCallback(line_item, $(this));
            }
          } else {
            ShopifyAPI.onItemAdded(line_item, $(this));
          }
        },
        error: function(data) {
          console.log(22, data);
        }
      });
    });
}
function ajaxGetSections(section_filename,ele_obj,callback){
  if (section_filename && ele_obj && callback) {
    $.ajax({
        url: '/?sections='+section_filename,
        type: 'GET',
        dataType: "json",
        cache: false,
        success: function(data) {
          callback(ele_obj, data);
        },
        error: function(data) {
          console.log('section', data);
        }
    });
  }
}
function ajaxGetRecommendations(product_id,section_filename,limit,ele_obj,callback){
  if (section_filename && ele_obj && callback) {
    $.ajax({
        url: '/recommendations/products?product_id='+product_id+'&section_id='+section_filename+'&intent=related&limit='+limit,
        type: 'GET',
        dataType: "html",
        cache: false,
        success: function(data) {
          callback(ele_obj, data);
        },
        error: function(data) {
          console.log('section', data);
        }
    });
  }
}
function clearFilterResultMethod(){ // 集合页面筛选及清除功能
  $(document).on('click', '.collection-filter-result .filter-result-item', function(e) {
    const curClass = $(this).attr('class').trim();
    const splitClass = curClass.split(' ');
    let curClass1 = curClass
    if (splitClass.length > 1) {
      curClass1 = splitClass[1].trim()
    }
    const $dom =  $(window).width() > 990 ? $('.content-page .filter_sidebar_general .filter-tag') : $('.filter-to-left .filter_sidebar .filter-tag');
    $dom.find('.'+curClass1).click();
    $(this).remove();
    e.stopPropagation();
  });
  $(document).on('click', '.collection-filter-result .clear-all, .mobile-clear-btns .clear-all', function(e) {
    const $dom =  $('.collection-filter-result');
    collectionFilter(e);
    $dom.find('.filter-result-item').remove();
    $dom.hide();
  });
  $(document).on('click', '.mobile-clear-btns .mobile-clear-right-btns', function(e) {
    $('.filter-to-left').removeClass('active');
    $('.bg-minicart').removeClass('active');
    $('.mobile-clear-btns').css('left', '-100%');
    $('body').removeClass('cartover');
  });
}

function productActiveMethod() { // 产品活动详情功能
  $(document).on('click', '.share-model .share-model-close', function(e) {
    $('.share-model').hide();
  })
  $(document).on('click', '.content-page-onsale-detail .btn_share', function(e) {
    $('.share-model').show();
    const value = $(".share-model .share-copy-link").val();
    if (!value) {
      $(".share-model .share-copy-link").val(window.location.href);
    }
  })
}
function productCoupupIcon() { //优惠券事件
   $(document).on('click', '.sub-coupup_icon_pc_content', function(e) {
    //alert(jQuery.cookie('success_pop_newletter'))
    if(jQuery.cookie('success_pop_newletter')){ // 已订阅
      const isHidden = $(".newsletter-subscribed-success-popup").is(":hidden");
      if (isHidden) {
        $('.newsletter-subscribed-success-popup').html($('#footer-newsletter .newsletter-subscribed-success-already').html()).show();
        setTimeout(() => {
          $('.newsletter-subscribed-success-popup').hide();
        }, 5000);
      } else {
        $('.newsletter-subscribed-success-popup').hide();
      }
    } else { // 没有订阅
      $('.jsengo_popup').show();
    }
  })
  $(document).on('click', '.coupon-copy-code-btn', function(e) {
    copyMethod($(this).attr('data'));
  });
  if($('#footer-newsletter .newsletter-subscribed-success-ok').length > 0){
    jQuery.cookie('success_pop_newletter', '1', {expires: 1, path:'/', domain: '' });
  }
  if(jQuery.cookie('success_pop_newletter') || jQuery.cookie('brilliant_pop_newletter')) { //已订阅和已弹窗
    $('.sub-coupup_icon_pc').removeClass('hide');
  }
}
function moveRightMethod() { //母亲节活动
   $(document).on('touchend', '.product-grid-row-arrow', function(event) {
     $('.product-grid-row-fixed-outer  .choice-reason-list').scrollLeft( $('.product-grid-row-fixed-outer .choice-reason-list')[0].scrollWidth);
   })
   if ($(window).width() < 990){
     const widthData = $('.product-grid-row-fixed').width();
     const widthData1 = (Number(widthData) - 60 )/3;
     const widthData2 = (widthData1+10)*6 + 10;
     $('.product-grid-row-fixed-outer  .choice-reason-list-ul li').css('width', widthData1+'px');
     $('.product-grid-row-fixed-outer  .choice-reason-list-ul').css('width', widthData2+'px');
   }
   $(window).scroll(function() {
    const $dom = $('.product-grid-row-fixed');
    const classAtrr = $dom.attr('class')
    if ($(window).width() < 990){
      if ($(window).scrollTop() > 550) {
         classAtrr && classAtrr.indexOf('mobile-row-fixed') == -1 && $dom.addClass('mobile-row-fixed');
         $dom.find('.product-grid-row-fixed-outer').show();
      } else {
         classAtrr && classAtrr.indexOf('mobile-row-fixed') > -1 && $dom.removeClass('mobile-row-fixed');
         $dom.find('.product-grid-row-fixed-outer').hide();
      }
    }
  });
}

function checkoutListMethod() { 
  $(document).on('click', '.image-list-slick-room-modal .room-good-list-btn .roomGoodButton1', function(e) {
    $('.image-list-slick-room-modal .room-modal-bottom-btns .roomGoodButton1').removeClass('viewCheckOut').click();
  });
  $(document).on('click', '.image-list-slick-room-modal .room-good-list-btn .roomGoodButton', function(e) {
    $('.image-list-slick-room-modal .room-modal-bottom-btns .roomGoodButton1').addClass('viewCheckOut').click();
     window.localStorage.setItem('checkoutUrl', 1);
    //  setTimeout(function() {
    //     $('a.button-checkout').length > 0 && $('a.button-checkout')[0].click();
    // }, 1800)
    // $('.js-minicart').removeClass('active')
  })
}

function addHrefAttrMethod() { //解决a标签没有链接地址时， 点击刷新当前页面问题
  const pictureDom = $('.section-slideshow-v1  .picture-slideshow a');
  for (let i = 0 ; i < pictureDom.length; i ++) {
    const urlText = $(pictureDom[i]).attr('href');
    if (!urlText || urlText=='#') {
       $(pictureDom[i]).attr('href', 'javascript:void(0)').css('cursor', 'default');
    }
  }
}

function checkEmailValMethod() { // 邮箱校验
  $('#mc_embed_signup .form-group .form-control').on('input', function(event) {
    const isPass = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(event.target.value);
    $('#mc_embed_signup .form-group .control_error_tip').remove();
    $('#mc_embed_signup .form-group .btn-primary').attr('disabled', false)
    if (!isPass) {
      const msg = event.target.value ? 'Please enter a valid email address. For example sk@sikaic.com' :  'This is a required field'
      $(this).after('<p class="control_error_tip">'+msg+'</p>')
      $('#mc_embed_signup .form-group .btn-primary').attr('disabled', true)
    }
  })
}

function openMobileDialogMethod() { // 移动端导航栏弹窗
  if ($(window).width() < 990){
     const widthData = $('.breadcrumb_collection .collection-item-list').width();
     const num =  $('.breadcrumb_collection .collection-item-list .collection-item-list-ul').children();
     const len = num.length > 2 ? num.length : 3;
     const widthData1 = (Number(widthData))/3 - 3;
     const widthData2 = widthData1*len + 10;
     $('.breadcrumb_collection .collection-item-list .collection-item-list-ul li').css('width', widthData1+'px');
     $('.breadcrumb_collection .collection-item-list .collection-item-list-ul').css('width', widthData2+'px').css('opacity', 1);
  } else {
     const logoDom =  $("#header .container .logo");
     const left = logoDom.length > 0 ? logoDom[0].getBoundingClientRect().left : 0;
     const listDom = $('#header .navbar .nav-item');
     const navWidth = $("#header").width();
     for( let i = 0; i < listDom.length; i++ ) { // 计算导航栏位置
       const len = $(listDom[i]).find('.nav-child-item-content-list').children();
       if (len.length < 4) {
          const leftWidth = $(listDom[i])[0].getBoundingClientRect().left;
          const rightWidth = $(listDom[i])[0].getBoundingClientRect().right;
          let leftWidth2 = parseInt(leftWidth) - parseInt(left);
          const navItem = $(listDom[i]).find('.nav-child-item');
          const navItemWidth = navItem.outerWidth();
          const leftAllWidth = parseInt(leftWidth) + parseInt(navItemWidth);
          if (leftAllWidth > navWidth) {
            leftWidth2 = leftWidth2 - (parseInt(navItemWidth)/3)
          }
          navItem.css('left', leftWidth2);
       }
     }
  }
  
  $('.mobile-collection-menu-model .mobile-collection-menu-close').on('touchend', function(e) {
    $('.mobile-collection-menu-mask').hide();
    $('.mobile-collection-menu-model').css('transform', 'translateY(-100%)');
    $('body').removeClass('cartover');
  })
  
  $('.collection-item-mobile-arrow').on('touchend', function(e) {
    $('.mobile-collection-menu-mask').show();
    $('.mobile-collection-menu-model').css('transform', 'translateY(0%)');
    $('body').addClass('cartover');
    e.stopPropagation();
    return false
  })
}

function blogV1(){
  $('.js-blog-v1').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    
    prevArrow:'<button type="button" class="prev-slide"><i class="fa fa-angle-left"></i> </button>',
    nextArrow:'<button type="button" class="next-slide"> <i class="fa fa-angle-right"></i></button>',
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrow: false,
          dots: false
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: false
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false
        }
      }
    ]
  });
}